import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartStore } from '../../../../core/stores/cart.store';
import { CartItem, MenuItemForPayment, MenuItemVariationValidation } from '../../../../core/models/cart-item.model';
import { RestaurantStore } from '../../../../core/stores/restaurant.store';
import { ApplyPromoCodeProcess, PaymentStore, StatePayment, VerifyProcess } from 'src/app/core/stores/payment.store';
import {
  Coupon,
  Group,
  Merchant,
  Restaurant,
  RestaurantAddress,
  RestaurantAvailableStatus,
  RestaurantCategory,
  RestaurantProduct,
  Taxes,
  VariationInventoryInfo,
  WorkDay
} from '../../../../core/models/restaurant.model';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RestaurantService } from '../../../../core/services/restaurant.service';
import { PaymentService } from '../../../../core/services/payment.service';
import { PaymentComponent } from '../../components/payment/payment.component';
import { RouteService } from '../../../../core/services/route.service';
import { DatePipe, LowerCasePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import {
  Address,
  CreateSubscriptionData,
  DateTime,
  DeliveryAddress,
  DeliveryPreEstimateRequest,
  DeliveryPreEstimateResponseData,
  DeliveryRequestData,
  DeliveryResponseData,
  DeliveryType,
  FulfillmentType,
  SelectDataState,
  SubscriptionPhase,
  TipType
} from '../../../../core/models/order.model';
import { AlertController, IonContent, ModalController, Platform, PopoverController } from '@ionic/angular';
import { DeliveryTypeItem, FulfillmentTypeItem } from '../../models/location.model';
import { StorageService } from '../../../../core/services/storage.service';
import {
  CITY_FLAVOR_LOCATIONS,
  EMAIL_PATTERN,
  STONE_CREEK_MERCHANT_ID,
  STORAGE_CUSTOMER_DATA,
  STORAGE_TAB_DATA
} from '../../../../core/constants';
import {
  BillingAddress,
  GroupOrderTab,
  LoyaltyBannerType,
  Order,
  OrderTab,
  TabInStorage
} from '../../../../core/models/payment-item.model';
import { OrderApiService } from '../../../../core/services/order.api.service';
import { ItemValidateService } from '../../../../core/services/item-validate.service';
import { ProductModalComponent } from '../../../../shared/components/product-modal/product-modal.component';
import { PickUpDateTimeComponent } from '../../components/pick-up-date-time/pick-up-date-time.component';
import { Customer, LoyaltyRewardScope, LoyaltyRewardTier } from '../../../../core/models/customer.model';
import { FormatDataService } from '../../../../core/services/format-data.service';
import * as moment from 'moment';
import { ModalInfo } from '../../../../core/models/notification.model';
import { CountdownComponent } from 'ngx-countdown';
import { GiftCard, PartialBalance } from '../../../../core/models/gift-card.model';
import { GiftCardService } from '../../../../core/services/gift-card.service';
import { VerifyPhoneNumberComponent } from 'src/app/shared/components/verify-phone-number/verify-phone-number.component';
import { Platforms } from 'src/app/core/enums/util.enum';
import { UtilService } from 'src/app/core/services/util.service';
import { GiftCardStatus } from '../../../../core/enums/gift-card.enum';
import { ItemService } from '../../../../core/services/item.service';
import { DiscountService } from '../../../../core/services/discount.service';
import { Tip } from '../../../../core/enums/tip.enum';
import { MinMaxOrderService } from '../../../../core/services/min-max-order.service';
import {SharedOrderService} from '../../../../core/services/shared-order.service';
import {UrlParam} from '../../../../core/enums/group-param.enum';
import { MerchantStore } from 'src/app/core/stores/merchant.store';
import { OrderWithFlavorStore } from 'src/app/core/stores/orderwithflavor.store';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
})
export class CheckoutComponent implements OnInit, OnDestroy {
  public menuItemsInCart: CartItem[];
  public menuItemsValidations: MenuItemVariationValidation[] = [];
  public fulfillmentTypeItems: FulfillmentTypeItem[] = [];
  public deliveryTypeItems: DeliveryTypeItem[] = [];
  public currentModal = null;
  public paymentErrorMessage: string;
  public estimatedTimeInMinutes: number;
  public hideETA: boolean;
  public forceTouched = false;
  public tabOptionSelected = false;
  public tableNumberTouched = false;
  public schedulePickupInvalid = true;
  public phoneInvalid = true;
  public tippingInvalid = true;
  public selectedProduct: RestaurantProduct;
  public selectedCartProduct: MenuItemForPayment;
  public selectedItemIndex: number;
  public isShowProductModal = false;
  public isLoading = false;
  public isUpdatingTab = false;
  public isNeedSharingPhoneNumber = false;
  public isShowTimeOverErrorMessage = false;
  public isShowEstimateErrorMessage = false;
  public estimateErrorMessage = '';
  public isTab = false;
  public isDateTimeModalOpen = false;
  public tabUpdateQueue = [];
  public isShowDiscountList = false;
  public isShowInclusiveTaxesList = false;
  public isShowExclusiveTaxesList = false;
  public isShowNotificationModal = false;
  public isWaitingDeliveryTime = false;
  public isEstimateHaveExpiresTime = false;
  public isShowCountdown = false;
  public saveDeliveryAddress = false;
  public currencySign = '$';
  public currency = 'USD';
  public token = '';
  public customerAddresses: DeliveryAddress[] = [];
  public deliveryAddress: DeliveryAddress = { street: '', suite: '', city: '', state: '', postalCode: '', instructions: '' };
  public countdownConfig = { leftTime: 270, format: 'm:ss' };
  public taxes: Taxes[];
  private destroyed$ = new Subject<void>();
  private giftCard: GiftCard = new GiftCard();
  public flexibleGiftCardBalance: number;
  public tip = Tip;
  public deliveryType: DeliveryType | string;
  public delivery = DeliveryType;
  public tabError: boolean;
  public tabErrorMessage: string;
  public selectedDeliveryLocation: string;
  public isShowDeliveryLocationModal: boolean;
  public sharedOrderId: string;
  public isPhoneValid: boolean;

  @ViewChild(IonContent, { static: true })
  public content: IonContent;
  @ViewChild(PaymentComponent, { static: true })
  public payment: PaymentComponent;
  @ViewChild('phoneField', { static: false, read: ElementRef })
  public phoneFieldComponent: ElementRef;
  @ViewChild('tipDriver', { static: false, read: ElementRef })
  public tipAmountFieldComponent: ElementRef;
  @ViewChild('scheduledPickupField', { static: false, read: ElementRef })
  public scheduledPickupField: ElementRef;
  @ViewChild('paymentField', { static: false, read: ElementRef })
  public paymentField: ElementRef;
  @ViewChild('tableNumberField', { static: false, read: ElementRef })
  public tableNumberField: ElementRef;
  @ViewChild('enableTabField', { static: false, read: ElementRef })
  public enableTabField: ElementRef;
  @ViewChild('deliveryTimepicker', { static: false, read: ElementRef })
  public deliveryTimepicker: ElementRef;
  @ViewChild('deliveryAddressForm', { static: false, read: ElementRef })
  public deliveryAddressForm: ElementRef;
  @ViewChild('countdown', { static: false })
  public countdown: CountdownComponent;
  @ViewChild('subscriptionDaysSelecting', { static: false, read: ElementRef })
  public subscriptionDaysSelect: ElementRef;
  @ViewChild('subscriptionPeriodSelecting', { static: false, read: ElementRef })
  public subscriptionPeriodSelect: ElementRef;

  @ViewChild(VerifyPhoneNumberComponent) children: VerifyPhoneNumberComponent;

  public isScrollStartPosition = true;
  public showTipsExpanded = false;
  public driverShowTipExpand = false;
  public showTableNumberExpanded = false;
  public showPhoneNumber = true;
  public handoffLocationNumbered = false;
  private isNavigateToCloseTab = false;

  // loyalty
  public filteredLoyaltyRewards: LoyaltyRewardTier[];

  // location
  public restaurant: Restaurant;
  public workHoursDaysInAdvance: WorkDay[];
  public locationId: string;
  private previousLocationId: string;
  public availableRestaurant: RestaurantAvailableStatus = new RestaurantAvailableStatus();

  // group
  public group: Group = new Group();
  public groupRestaurants: Restaurant[];
  public editedProductRestaurant: Restaurant;
  public restaurantsWorkHoursDaysInAdvance: WorkDay[][] = [];
  public groupRestaurantsFulfillment = [];
  private groupId: string;

  // flavor
  private merchant: Merchant
  public shifts: any[];
  public cfDeliveryLocations:string[] = [];
  public isCfDeliveryEnabled:boolean = false;

  public isSkybox = false;

  public readonly termsLink = 'https://www.kyoo.tech/kyoo/#/terms';
  public readonly privacyLink = 'https://www.kyoo.tech/kyoo/#/privacy';
  public readonly defaultSmartTippingThreshold = 10;
  private readonly defaultFlatTippingItems = [0, 1, 3, 5];
  private readonly defaultPercentageTippingItems = [0, 15, 20, 25];
  private _selectedFulfillmentTypeItem: FulfillmentTypeItem = new FulfillmentTypeItem();
  private readonly pickupFulfillmentType: FulfillmentTypeItem = new FulfillmentTypeItem(
    'Pickup',
    'icon-pickup',
    true,
    FulfillmentType.PICKUP,
    0
  );
  private readonly curbsideFulfillmentType: FulfillmentTypeItem = new FulfillmentTypeItem(
    'Curbside',
    'icon-curbside',
    true,
    FulfillmentType.CURBSIDE,
    0
  );
  private readonly tablesideFulfillmentType: FulfillmentTypeItem = new FulfillmentTypeItem(
    'Tableside',
    'icon-tableside',
    true,
    FulfillmentType.TABLESIDE,
    0
  );
  private readonly deliveryFulfillmentType: FulfillmentTypeItem = new FulfillmentTypeItem(
    'Delivery',
    'icon-delivery',
    true,
    FulfillmentType.DELIVERY,
    0
  );
  private readonly fridgeFulfillmentType: FulfillmentTypeItem = new FulfillmentTypeItem(
    'Fridge',
    'icon-fridge',
    true,
    FulfillmentType.FRIDGE,
    0
  );
  private handoffFulfillmentType: FulfillmentTypeItem = new FulfillmentTypeItem(
    'XSide',
    'icon-pickup',
    true,
    FulfillmentType.HANDOFF,
    0
  );

  private defaultPointName = { one: 'loyalty point', other: 'loyalty points' };
  private defaultDaysOfWeek: SelectDataState[] = [
    { selected: false, param: 'Sun', value: 'SUNDAY' },
    { selected: false, param: 'Mon', value: 'MONDAY' },
    { selected: false, param: 'Tue', value: 'TUESDAY' },
    { selected: false, param: 'Wed', value: 'WEDNESDAY' },
    { selected: false, param: 'Thu', value: 'THURSDAY' },
    { selected: false, param: 'Fri', value: 'FRIDAY' },
    { selected: false, param: 'Sat', value: 'SATURDAY' },
  ];

  private isShowPromoCodeField: boolean;
  public promoCode = '';
  public showWrongPromoCodeError = false;

  public get isStoneCreek(): boolean {
    return this.utilService.isStoneCreek();
  }

  private get interval(): number {
    return this.formatDataService.getIntervalFromDuration(this.cartStore.pickupWindowDuration);
  }

  public get selectedLocationId(): string {
    return this.selectedCartProduct && this.selectedCartProduct.locationId;
  }

  public get selectedLocation(): Restaurant {
    if (this.isGroup) {
      return this.restaurantStore.findLocationById(this.groupRestaurants, this.selectedCartProduct.locationId);
    }
    return this.restaurant;
  }

  public get serviceChargeText(): string {
    return this.restaurant.serviceChargeName ? this.restaurant.serviceChargeName : `Service Charge`;
  }

  public get loyaltyBannerType(): LoyaltyBannerType {
    return LoyaltyBannerType.CHECKOUT;
  }

  public get isShowUseLoyaltyCheckbox(): boolean {
    return (
      !this.isTabsSelected &&
      Object.keys(this.cartStore.orderMap).length === 1 &&
      this.isLoyaltyRewardsAvailable &&
      this.isLoyaltyEnabled &&
      this.paymentStore.verificationCustomer
    );
  }

  public get isShowUseLoyaltyRadioGroup(): boolean {
    if (this.isLoyaltyRewardsAvailable && this.paymentStore.selectedLoyaltyReward == null) {
      this.paymentStore.selectedLoyaltyReward = this.filteredLoyaltyRewards[0];
      this.orderApiService.calculateOrders();
    }
    return this.paymentStore.useLoyaltyChecked && this.isShowUseLoyaltyCheckbox;
  }

  public get isLoyaltyEnabled(): boolean {
    return !this.isGroup && this.cartStore.isLoyaltyEnabled && this.cartStore.loyalty && this.cartStore.items.length > 0;
  }

  public get showPhoneFieldBottom(): boolean {
    return this.isLoyaltyEnabled || !!this.cartStore.subscriptionsData;
  }

  public get pointsName(): any {
    if (this.restaurantStore && this.restaurantStore.loyaltyPointsName) {
      return this.restaurantStore.loyaltyPointsName;
    }
    return this.defaultPointName;
  }

  public get daysToSelect(): SelectDataState[] {
    return this.defaultDaysOfWeek;
  }

  public get deadlineTime(): string {
    return this.formatDataService.formatDurationToTimeString(this.restaurant.cancellationDeadlineDuration);
  }

  public get showLoyaltyBanner(): boolean {
    if (this.paymentStore.customer && !this.paymentStore.customer?.loyaltyAccountId) {
      return false;
    }
    return this.isLoyaltyEnabled && !this.paymentStore.useLoyaltyChecked && this.cartStore.loyalty.pointsValue > 0;
  }

  public get isLoyaltyRewardsAvailable(): boolean {
    return (
      this.paymentStore.customer?.loyaltyRewardsTier != null &&
      this.paymentStore.customer?.loyaltyRewardsTier?.length > 0 &&
      this.filteredLoyaltyRewards != null &&
      this.filteredLoyaltyRewards?.length > 0
    );
  }

  public get isMobile(): boolean {
    return this.platform.is('mobile') || this.platform.width() < 600;
  }

  public get isMobileEnabled(): boolean {
    if (this.isGroup) {
      return true;
    }
    return this.restaurant && this.restaurant?.isMobileEnabled;
  }

  public get isGroup(): boolean {
    return this.restaurantStore.isGroup;
  }

  public get isShowTimePicker(): boolean {
    return !!this.restaurant || !!this.group;
  }

  public get isDisableAsap(): boolean {
    if (!this.group && !this.restaurant) {
      return false;
    }
    return this.isGroup ? !!this.groupRestaurants.find((restaurant) => restaurant.disableASAP === true) : this.restaurant.disableASAP;
  }

  public get isAllowScheduledPickups(): boolean {
    if (!this.group && !this.restaurant) {
      return false;
    }

    return this.isGroup ? !!this.groupRestaurants?.find((restaurant) => restaurant.allowScheduledPickups === true) : this.restaurant.allowScheduledPickups;
  }

  public get totalTaxesPrice(): number {
    if (this.isDeliverySelected) {
      return this.cartStore.taxesPrice;
    } else if (this.isGroup) {
      return this.cartStore.groupTaxesPrice;
    } else {
      return this.cartStore.totalTaxesPrice;
    }
  }

  public get pickupDaysInAdvance(): number {
    if (!this.group && !this.restaurant) {
      return 0;
    }
    if (this.isGroup) {
      let maxPickupDaysInAdvance = 0;
      for (const restaurant of this.groupRestaurants) {
        if (Number(restaurant.pickupDaysInAdvance) > maxPickupDaysInAdvance) {
          maxPickupDaysInAdvance = Number(restaurant.pickupDaysInAdvance);
        }
      }
      return maxPickupDaysInAdvance;
    }
    return Number(this.restaurant?.pickupDaysInAdvance);
  }

  public get isRestaurantClosed(): boolean {
    if (!this.group && !this.restaurant) {
      return false;
    }
    if (this.isGroup) {
      if (this.editedProductRestaurant) {
        if (!this.editedProductRestaurant.isAcceptingOrders || !this.editedProductRestaurant.isMobileEnabled) {
          return true;
        }
      }
      return false;
    }
    if (this.restaurantStore.timeRangeParams) {
      return (
        !this.restaurant.isAcceptingOrders || !this.restaurant.isMobileEnabled || !this.formatDataService.isTimeNowInWorkRange(this.workHoursDaysInAdvance[0])
      );
    }
    return !this.restaurant.isAcceptingOrders || !this.restaurant.isMobileEnabled;
  }

  public get isAcceptOrders(): boolean {
    if (!this.group && !this.restaurant) {
      return false;
    }
    return this.isGroup ? !!this.groupRestaurants.find((restaurant) => restaurant.isAcceptingOrders === true) : !this.isRestaurantClosed;
  }

  public get notificationInfo(): ModalInfo {
    return new ModalInfo('Your delivery quote has expired. Please press continue to keep placing your order.', 'Continue');
  }

  public get isHidePickupTime(): boolean {
    if(this.restaurant) {
      return this.restaurant.hidePickupTime;
    } else {
      return false;
    }
  }

  public get isUseFlavorShiftsTime(): boolean {
    if(this.merchant) {
      return this.merchant.useFlavorShiftsTime
    } else {
      return false
    }
  }

  public get invalid(): boolean {
    if (
      !this.isMobileEnabled ||
      !this.paymentStore.customer ||
      !this.isPhoneValid ||
      !this.menuItemsInCart.length ||
      this.isCustomerVerification ||
      ((this.cartStore.getTip(this.tip.restaurant) == null || this.cartStore.getTip(this.tip.driver) == null) &&
        this.cartStore.tippingEnabled && !this.paymentStore.createTabChecked) ||
      this.nameFieldsInvalid ||
      !this.checkItemsValid ||
      this.phoneInvalid ||
      this.deliveryAddressInvalid ||
      this.deliveryEstimateInvalid ||
      this.deliveryTimeInvalid ||
      this.billingAddressInvalid ||
      this.emailAddressInvalid ||
      this.pickupTimeInvalid ||
      !this.isSelectedSubscriptionDay ||
      !this.isSelectedSubscriptionPeriod
    ) {
      return true;
    }
    return this.isValidFulfillment();
  }

  private isValidFulfillment(): boolean {
    if (this.restaurant) {
      return this.checkRestaurantFulfillmentInvalid(this.restaurant);
    } else if (this.group) {
      for (const restaurant of this.groupRestaurants) {
        if (this.checkRestaurantFulfillmentInvalid(restaurant)) {
          return true;
        }
      }
      return false;
    }
  }

  public checkRestaurantFulfillmentInvalid(restaurant: Restaurant): boolean {
    switch (this._selectedFulfillmentTypeItem.type) {
      case FulfillmentType.CURBSIDE: return this.minMaxOrderService.checkMinMaxOrder(restaurant, FulfillmentType.CURBSIDE);
      case FulfillmentType.DELIVERY: return this.minMaxOrderService.checkMinMaxOrderDelivery(restaurant, FulfillmentType.DELIVERY);
      case FulfillmentType.HANDOFF: return this.minMaxOrderService.checkMinMaxOrderHandoff(restaurant, this.handofTableNumberFieldInvalid, FulfillmentType.HANDOFF);
      case FulfillmentType.PICKUP: return this.minMaxOrderService.checkMinMaxOrder(restaurant, FulfillmentType.PICKUP);
      case FulfillmentType.TAB: return this.minMaxOrderService.checkMinMaxOrder(restaurant, FulfillmentType.TAB);
      case FulfillmentType.TABLESIDE: return this.minMaxOrderService.checkMinMaxOrderTableSide(restaurant, this.tabOptionSelected, this.tableNumberFieldInvalid);
    }
  }

  public get checkItemsValid(): boolean {
    this.updateMenuItemsValidations();
    return !this.menuItemsValidations.find((item) => item.isValid === false);
  }

  public get disabledSubmit(): boolean {
    return this.isLoading ||
      this.cartStore.updateCartInProgress ||
      this.paymentStore.isWaitingUpdate ||
      this.showMaxAmountErrorMessage ||
      this.showMinAmountErrorMessage ||
      this.cartStore.isFutureOrderError;
  }

  public get payButtonText(): string {
    if (this.cartStore.updateCartInProgress || this.paymentStore.isWaitingUpdate) {
      return 'Calculating...';
    } else if (this.isLoading) {
      return 'Submitting order...';
    } else if (this.paymentStore.createTabChecked) {
      return 'Start tab';
    } else if (this.isSubscriptionCheckout) {
      return 'Subscribe';
    } else if (this.sharedOrderId) {
      return 'Add items to the shared order';
    } else {
      return this.isStoneCreek ? 'Place Order' : 'Pay';
    }
  }

  public get showBaseTippingField(): boolean {
    return this.cartStore.tippingEnabled && !this.paymentStore.createTabChecked;
  }

  public get tipAmounts(): any {
    let defaultTips = this.defaultFlatTippingItems;
    if (this.tipType === TipType.FLAT) {
      defaultTips = this.defaultFlatTippingItems;
    } else if (this.tipType === TipType.PERCENTAGE) {
      defaultTips = this.defaultPercentageTippingItems;
    } else if (this.tipType === TipType.SMART) {
      if (this.cartStore.totalPrice < this.defaultSmartTippingThreshold) {
        return this.defaultFlatTippingItems;
      } else {
        return this.defaultPercentageTippingItems;
      }
    }
    const targetDefaultTippingItems = this.cartStore.autoGratuityPercent !== 0 ? [] : defaultTips;
    if (this.restaurant) {
      return this.restaurant.tipAmounts.length === 0 ? targetDefaultTippingItems : this.restaurant.tipAmounts;
    }
    if (this.group) {
      return this.group.tipAmounts.length === 0 ? targetDefaultTippingItems : this.group.tipAmounts;
    }
    return targetDefaultTippingItems;
  }

  public get tipType() {
    if (this.isGroup) {
      return this.group && this.group.tipType ? this.group.tipType : 'FLAT';
    } else if (this.restaurant) {
      return this.restaurant.tipType ? this.restaurant.tipType : 'FLAT';
    } else {
      return 'FLAT';
    }
  }

  public get autoGratuityPercent(): number {
    return this.cartStore.autoGratuityPercent ? this.cartStore.autoGratuityPercent : 0;
  }

  public getGratuityPercent(type: Tip): number {
    return this.cartStore.getGratuityPercent(type, this.isDeliverySelected, this.deliveryType, this.availableRestaurant.deliveryCourier, this.availableRestaurant.deliverySeller);
  }

  public get isRestaurantTip(): boolean {
    if (!this.isGroup && this.isDeliverySelected && this.deliveryType === this.delivery.COURIER) {
      return this.restaurant.enableRestaurantTip;
    }
    return true;
  }

  public get closeInactiveTabsAfterMinutes(): number {
    if (this.isGroup) {
      return this.group.closeInactiveTabsAfterMinutes ? this.group.closeInactiveTabsAfterMinutes : 45;
    } else {
      return this.restaurant.closeInactiveTabsAfterMinutes ? this.restaurant.closeInactiveTabsAfterMinutes : 45;
    }
  }

  public get deliveryFee(): number {
    return (this.cartStore.deliveryResponseData.delivery_fee_cents + this.cartStore.deliveryResponseData.kyoo_fee_cents) / 100;
  }

  public get deliveryCost(): number {
    return this.isDeliverySelected ? this.cartStore.deliveryFee / 100 : 0;
  }

  public get authAmountInCents(): string {
    if (this.isGroup) {
      const maxAuthAmountInCents = this.groupRestaurants.reduce(
        (max, restaurant) => (restaurant.authAmountInCents > max ? restaurant.authAmountInCents : max),
        this.groupRestaurants[0].authAmountInCents
      );
      return maxAuthAmountInCents
        ? `${this.restaurantStore.restaurantCountryInfo.currencySign}${this.getFormattedPrice(maxAuthAmountInCents / 100)}`
        : 'temporary';
    } else {
      return this.restaurant.authAmountInCents
        ? `${this.restaurantStore.restaurantCountryInfo.currencySign}${this.getFormattedPrice(this.restaurant.authAmountInCents / 100)}`
        : 'temporary';
    }
  }

  public showTips(tipType: Tip): boolean {
    switch (tipType) {
      case Tip.driver: return this.isShowTips('driverShowTipExpand');
      case Tip.restaurant: return this.isShowTips('showTipsExpanded');
    }

  }

  public checkPhoneValidation(event): void {
    this.isPhoneValid = event;
  }

  private isShowTips(tip: string): boolean {
    if (this.isGroup) {
      return this.group && this[tip];
    }
    if (tip === 'driverShowTipExpand' && !this.isShowDriverTip) {
      return false;
    }
    return this.restaurant && this[tip] && this.showBaseTippingField;
  }

  public get isShowRestaurantTip(): boolean {
    if (this.sharedOrderService.sharedOrderId$) {
      return false;
    }
    return this.showBaseTippingField && this.isRestaurantTip;
  }

  public get isShowDriverTip(): boolean {
    if (this.sharedOrderService.sharedOrderId$) {
      return false;
    }
    if (this.availableRestaurant.deliveryCourier && this.availableRestaurant.deliverySeller) {
      return this.showBaseTippingField && this.isDeliverySelected && this.deliveryType === this.delivery.COURIER;
    } else if (this.availableRestaurant.deliveryCourier) {
      return this.showBaseTippingField && this.isDeliverySelected && this.deliveryType === this.delivery.COURIER;
    }
    return false;
  }

  public get total(): number {
    this.calculateGiftCardBalance();
    this.paymentService.setPartialBalance(new PartialBalance(this.flexibleGiftCardBalance, this.subTotal - this.flexibleGiftCardBalance));
    this.isValidFulfillment();
    return this.subTotal - this.flexibleGiftCardBalance;
  }

  public get tips(): number {
    return this.paymentStore.createTabChecked ? 0 : !this.cartStore.tab || this.cartStore.tab?.is_closed ? this.getTips() : 0;
  }

  private getTips(): number {
    if (this.isDeliverySelected) {
      if (this.isShowRestaurantTip && this.isShowDriverTip) {
        return this.cartStore.getTip(this.tip.driver) + this.cartStore.getTip(this.tip.restaurant);
      } else if (this.isShowRestaurantTip) {
        return this.cartStore.getTip(this.tip.restaurant);
      }
      return this.cartStore.getTip(this.tip.driver);
    }
    return this.cartStore.getTip(this.tip.restaurant);
  }

  public get subTotal(): number {
    return this.cartStore.totalPrice + this.totalTaxesPrice + this.deliveryCost + this.tips;
  }

  public get isCustomerVerification(): boolean {
    return !this.paymentStore.verificationCustomer && this.isNameFieldsEmpty;
  }

  public get isNameFieldsEmpty(): boolean {
    return !(this.paymentStore.givenName && this.paymentStore.givenName.length > 0 && this.paymentStore.familyName && this.paymentStore.familyName.length > 0);
  }

  public get isNameKyooCustomer(): boolean {
    return (
      this.paymentStore.givenName === 'Kyoo' ||
      this.paymentStore.familyName === 'Customer' ||
      this.paymentStore.givenName === 'Kyoo Customer' ||
      this.paymentStore.givenName === 'null' ||
      this.paymentStore.familyName === 'null'
    );
  }

  public get nameFieldsInvalid(): boolean {
    return (this.isNameKyooCustomer && !this.isCustomerNameAvailable) || this.isNameFieldsEmpty;
  }

  public get deliveryAddressInvalid(): boolean {
    if (this.isDeliverySelected) {
      if (this.showDeliveryLocations) {
        return !this.selectedDeliveryLocation;
      }
      const address = this.paymentStore.deliveryAddress;
      if (address) {
        return !address.street || !address.state || !address.city || !address.postalCode;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  public get deliveryEstimateInvalid(): boolean {
    return this.isDeliverySelected && !this.cartStore.deliveryResponseData;
  }

  public get deliveryTimeInvalid(): boolean {
    return this.isDeliverySelected && !this.cartStore.deliveryAt;
  }

  public get isSelectedSubscriptionDay(): boolean {
    if (!this.isSubscriptionCheckout) {
      return true;
    }
    return !!this.daysToSelect.find((day) => day.selected);
  }

  public get isSelectedSubscriptionPeriod(): boolean {
    if (!this.isSubscriptionCheckout) {
      return true;
    }
    return !!this.selectedSubscriptionPhase.selectedPeriods.find((period) => period.selected);
  }

  public get showEnableTabError(): boolean {
    return this.forceTouched && !this.tabOptionSelected;
  }

  public get isCustomerNameAvailable(): boolean {
    if (this.paymentStore.verificationCustomer) {
      return !!(
        this.paymentStore.customer.givenName &&
        this.paymentStore.customer.givenName !== 'null' &&
        this.paymentStore.customer.familyName &&
        this.paymentStore.customer.familyName !== 'null' &&
        !this.isNameKyooCustomer
      );
    } else if (!this.paymentStore.verificationCustomer && !this.isNameFieldsEmpty) {
      return true;
    }
    return false;
  }

  public get tableNumberFieldInvalid(): boolean {
    if (!this.paymentStore.createTabChecked) {
      return this.restaurant?.isTablesideNumberRequired && !this.paymentStore.tableNumber;
    }
    return !this.paymentStore.tableNumber && this.isTableSideSelected;
  }

  public get handofTableNumberFieldInvalid(): boolean {
    return this.restaurant.handoffLocationNumbered ? !this.paymentStore.tableNumber : false;
  }

  public get pickupTimeInvalid(): boolean {
    if ((!this.restaurant && !this.groupRestaurants) || this.isSubscriptionCheckout) {
      return false;
    }
    return !this.cartStore.pickupAt && !this.isTableSideSelected && !this.isDeliverySelected && this.isAllowScheduledPickups;
  }

  public get emailAddressInvalid(): boolean {
    const emailRequired = this.isEmailRequired;
    if (emailRequired) {
      return !this.paymentStore.email || !EMAIL_PATTERN.test(String(this.paymentStore.email).toLowerCase());
    }
    return false;
  }

  public get billingAddressInvalid(): boolean {
    const billingAddressRequired = this.isBillingAddressRequired;
    if (billingAddressRequired) {
      if (!this.paymentStore.billingAddress) {
        return true;
      }
      const { address_line1, administrative_district_level1, locality, postal_code } = this.paymentStore.billingAddress;
      return !this.paymentStore.billingAddress || !address_line1 || !administrative_district_level1 || !locality || !postal_code;
    }
    return false;
  }

  public get isEmailRequired(): boolean {
    if (!this.restaurant && !this.groupRestaurants) {
      return false;
    }
    return this.isGroup ? !!this.groupRestaurants?.find((restaurant) => restaurant.requireEmail === true) : this.restaurant.requireEmail;
  }

  public get isBillingAddressRequired(): boolean {
    if (!this.restaurant && !this.groupRestaurants) {
      return false;
    }
    return this.isGroup ? !!this.groupRestaurants?.find((restaurant) => restaurant.requireBillingAddress === true) : this.restaurant.requireBillingAddress;
  }

  public get isSharedCardsEnabled(): boolean {
    if (!this.restaurant && !this.groupRestaurants) {
      return false;
    }
    return this.isGroup ? false : this.restaurant.isSharedCardsEnabled;
  }

  public get isDisableQuickCheckout(): boolean {
    if (!this.restaurant && !this.groupRestaurants) {
      return false;
    }
    return this.isGroup ? !!this.groupRestaurants?.find((restaurant) => restaurant.disableQuickCheckout === true) : this.restaurant.disableQuickCheckout;
  }

  public get isTableNumberExpanded(): boolean {
    return this.paymentStore.tableNumber == null || this.paymentStore.tableNumber.length === 0 || this.showTableNumberExpanded || this.tableNumberTouched;
  }

  public get showTableNumberError(): boolean {
    return (this.forceTouched || this.tableNumberTouched) && this.tableNumberFieldInvalid;
  }

  public get showTimeOverErrorMessage(): boolean {
    return this.isShowTimeOverErrorMessage;
  }

  public get showMinAmountErrorMessage(): boolean {
    return this.minMaxOrderService.isMinErrorMessage;
  }

  public get showMaxAmountErrorMessage(): boolean {
    return this.minMaxOrderService.isMaxErrorMessage;
  }

  public showDeliveryAddressError(value): boolean {
    return this.forceTouched && !value;
  }

  public get showErrorTextForDeliveryEstimate(): boolean {
    return this.isShowEstimateErrorMessage || (!this.cartStore.deliveryDurationData && this.forceTouched);
  }

  public get errorTextForDeliveryEstimate(): string {
    return this.estimateErrorMessage.length === 0 ? 'Please check your address and retry' : this.estimateErrorMessage;
  }

  public get showDeliveryTimeError(): boolean {
    return this.forceTouched && !this.cartStore.deliveryAt;
  }

  public get showSubscriptionDaySelectError(): boolean {
    return this.forceTouched && !this.isSelectedSubscriptionDay;
  }

  public get showSubscriptionPeriodSelectError(): boolean {
    return this.forceTouched && !this.isSelectedSubscriptionPeriod;
  }

  public get customerDeliveryAddress(): Address {
    if (!this.paymentStore.deliveryAddress) {
      return;
    }
    const { street, suite, city, state, postalCode, instructions } = this.paymentStore.deliveryAddress;
    return new Address(street, suite, city, state, postalCode, instructions);
  }

  public get isTabsEnabled(): boolean {
    if (!this.group && !this.restaurant) {
      return false;
    }
    return (
      this.isTableSideSelected &&
      (this.isGroup ? !!this.groupRestaurants?.find((restaurant) => restaurant.isTabsEnabled === true) : this.restaurant.isTabsEnabled)
    );
  }

  public get isTabsSelected(): boolean {
    return this.selectedFulfillmentTypeItem && this.selectedFulfillmentTypeItem.type === FulfillmentType.TABLESIDE && this.paymentStore.createTabChecked;
  }

  public get isStrictTabLanguageEnabled(): boolean {
    if (!this.group && !this.restaurant) {
      return false;
    }
    return this.isGroup ? !!this.groupRestaurants?.find((restaurant) => restaurant.enableStrictTabLanguage === true) : this.restaurant.enableStrictTabLanguage;
  }

  public get isSubscriptionCheckout(): boolean {
    return !this.isGroup && this.restaurantStore.subscriptionCode && !!this.restaurantStore.subscriptionCode.length;
  }

  public get isShowTableNumberField(): boolean {
    return this.isTableSideSelected || (this.isHandoffSelected && this.handoffLocationNumbered);
  }

  public get isTableSideSelected(): boolean {
    return this.selectedFulfillmentTypeItem && this.selectedFulfillmentTypeItem.type === FulfillmentType.TABLESIDE && !this.isRestaurantClosed;
  }

  public get isDeliverySelected(): boolean {
    return this.selectedFulfillmentTypeItem && this.selectedFulfillmentTypeItem.type === FulfillmentType.DELIVERY;
  }

  public get isHandoffSelected(): boolean {
    return this.selectedFulfillmentTypeItem && this.selectedFulfillmentTypeItem.type === FulfillmentType.HANDOFF;
  }

  public get isFridgeSelected(): boolean {
    return this.selectedFulfillmentTypeItem && this.selectedFulfillmentTypeItem.type === FulfillmentType.FRIDGE;
  }

  public get showPickupField(): boolean {
    return (
      this.selectedFulfillmentTypeItem &&
      this.selectedFulfillmentTypeItem.type !== FulfillmentType.DELIVERY &&
      this.selectedFulfillmentTypeItem.type !== FulfillmentType.TABLESIDE &&
      !this.isSubscriptionCheckout
    );
  }

  public get showFulfillmentTypes(): boolean {
    return this.fulfillmentTypeItems.length > 1;
  }

  public get selectedFulfillmentTypeItem(): FulfillmentTypeItem {
    return this._selectedFulfillmentTypeItem;
  }

  public get selectedSubscriptionPhase(): SubscriptionPhase {
    return this.cartStore?.subscriptionsData.find((phase) => phase.selected);
  }

  public get isDisablingCheckoutInfo(): boolean {
    return this.paymentStore.isWaitingUpdate || this.isWaitingDeliveryTime;
  }

  public get payButtonErrorText(): string {
    if (this.showTimeOverErrorMessage) {
      return `Network timeout error - please hit 'Pay' again to safely retry (don't worry, it won't create a duplicate!).`;
    } else if (this.showMinAmountErrorMessage) {
      return `Your cart does not meet the ${this.currencySign}${this.minMaxOrderService.minOrder} order minimum for\n` +
        `${this.selectedFulfillmentTypeItem.type}. Please keep adding to your cart.`;
    } else if (this.showMaxAmountErrorMessage) {
      return `Your cart exceeds the ${this.currencySign}${this.minMaxOrderService.maxOrder} order maximum for\n` +
        `${this.selectedFulfillmentTypeItem.type}. Please remove item(s) from your cart.`;
    } else if (this.orderApiService.calculateError) {
      return this.orderApiService.calculateError;
    } else {
      return null;
    }
  }

  public get currentPaymentErrorMessage(): string {
    if (this.paymentErrorMessage && this.paymentErrorMessage.includes('Your cart does not meet the order minimum')) {
      const totalAmountInCents = (this.cartStore.totalPrice + this.totalTaxesPrice + this.deliveryCost) * 100;
      const appFeePercentage = this.cartStore.deliveryResponseData.app_fee_cents / totalAmountInCents;
      if (!(totalAmountInCents >= 500 && appFeePercentage > 0.9) && !(totalAmountInCents < 500 && appFeePercentage > 0.6)) {
        this.paymentErrorMessage = null;
      }
    }
    return this.paymentErrorMessage;
  }

  public get selectAsapInTimepicker(): boolean {
    if (this.isGroup) {
      return true;
    }
    return !this.restaurant.disableASAP && this.restaurant.selectAsapByDefault;
  }

  public get deliveryAddressText(): string {
    if (this.selectedDeliveryLocation) {
      return this.selectedDeliveryLocation;
    }
    return 'Choose delivery location';
  }

  public get deliveryLocations(): string[] {
    if(this.isCfDeliveryEnabled && this.cfDeliveryLocations.length > 0){
      return this.cfDeliveryLocations;
    } else {
      return this.restaurant.sellerDeliveryLocations;
    }
  }

  public openDeliveryLocationModal(): void {
    this.isShowDeliveryLocationModal = !this.isShowDeliveryLocationModal;
  }

  public selectDeliveryLocation(location: string): void {
    this.selectedDeliveryLocation = location;
    this.isShowDeliveryLocationModal = false;
    this.paymentStore.deliveryAddress = new DeliveryAddress(
      this.restaurant.sellerDispatchAddress.addressLine,
      null,
      this.restaurant.sellerDispatchAddress.locality,
      this.restaurant.sellerDispatchAddress.state,
      this.restaurant.sellerDispatchAddress.postalCode,
      this.selectedDeliveryLocation
    );
    const deliveryRequestData: DeliveryPreEstimateRequest = new DeliveryPreEstimateRequest(this.customerDeliveryAddress);
    this.getDeliveryPreEstimate(this.locationId, deliveryRequestData);
  }

  public get deliveryTimePickerText(): string {
    const deliveryDuration = this.itemValidateService.convertLeadTimeToMinutes(this.cartStore.deliveryDurationData.duration);
    const duration = deliveryDuration ? Math.round(deliveryDuration) : 30;
    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;
    if (this.cartStore.deliveryAt) {
      return this.cartStore.deliveryAt !== 'asap'
        ? this.formatIsoString(this.cartStore.deliveryAt)
        : `ASAP: ${hours > 0 ? `${hours} hour` : ''} ${minutes} mins`;
    } else {
      return 'Choose delivery time';
    }
  }

  public get deliveryTimePicker(): any {
    return (this.paymentStore.phoneNumber && this.cartStore.deliveryDurationData);
  }

  public set selectedFulfillmentTypeItem(fulfillmentTypeItem: FulfillmentTypeItem) {
    this.allowCreateTab(false);
    if (this.isTab) {
      fulfillmentTypeItem.type = FulfillmentType.TAB;
    }
    this.paymentStore.setFulfilmentType(fulfillmentTypeItem.type);
    this._selectedFulfillmentTypeItem = fulfillmentTypeItem;
    this.paymentStore.createTabChecked = false;
    this.isWaitingDeliveryTime = false;
    if (fulfillmentTypeItem.type === FulfillmentType.DELIVERY) {
      if (this.paymentStore.deliveryAddress) {
        this.preEstimateDelivery();
      }
    }
    if (this.isGroup) {
      this.setGroupKyooFee();
    }
  }
  public get userVerified(): boolean {
    return this.paymentStore.verificationCustomer;
  }

  public get isCityFlavor(): boolean {
    return CITY_FLAVOR_LOCATIONS.some(location => location === this.locationId);
  }

  public get isShowDefaultDeliveryForm(): boolean {
    if (this.isGroup) {
      return true;
    }
    return (
      (this.restaurant.showSellerDeliveryLocations && !this.restaurant.sellerPoweredDeliveryEnabled)
        ? this.restaurant.courierPoweredDeliveryEnabled
        : !this.restaurant.showSellerDeliveryLocations && (this.restaurant.sellerPoweredDeliveryEnabled || this.restaurant.courierPoweredDeliveryEnabled)
    ) || false;
  }

  public get showDeliveryLocations(): boolean {
    if (this.isGroup) {
      return false;
    }
    return (this.restaurant.showSellerDeliveryLocations && this.restaurant.sellerPoweredDeliveryEnabled) || (this.isCfDeliveryEnabled && this.cfDeliveryLocations.length > 0);
  }

  public get isSubmitting(): boolean {
    return this.isLoading && (this.paymentStore.statePayment == StatePayment.SEND || this.paymentStore.statePayment == StatePayment.WALLET_PROCESS);
  }

  constructor(
    public cartStore: CartStore,
    public restaurantStore: RestaurantStore,
    public paymentStore: PaymentStore,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private lowerCasePipe: LowerCasePipe,
    private popoverController: PopoverController,
    private platform: Platform,
    private paymentService: PaymentService,
    private restaurantService: RestaurantService,
    private orderApiService: OrderApiService,
    private cookieService: CookieService,
    private storageService: StorageService,
    private modalController: ModalController,
    private routeService: RouteService,
    private itemValidateService: ItemValidateService,
    private leadTimeService: ItemValidateService,
    private giftCardService: GiftCardService,
    private formatDataService: FormatDataService,
    public utilService: UtilService,
    private alertController: AlertController,
    private minMaxOrderService: MinMaxOrderService,
    private itemService: ItemService,
    private discountService: DiscountService,
    public sharedOrderService: SharedOrderService,
    private merchantStore: MerchantStore,
    private orderWithFlavorStore: OrderWithFlavorStore
  ) {
    this.giftCardService.getGiftCard.subscribe(giftCard => {
      if (giftCard.state === GiftCardStatus.active) {
        this.giftCard = giftCard;
        this.flexibleGiftCardBalance = giftCard.balance;
        this.calculateGiftCardBalance();
      }
    });
  }

   ngOnInit() {
    this.cartStore.items$.subscribe(() => {
      this.menuItemsInCart = this.cartStore.cartItems;
      this.isTab = !!this.cartStore.tab || !!this.cartStore.groupTab;
    });
    this.isSkybox = this.router.url.includes('LDGN4QKDKW24D');
    this.isTab = !!this.cartStore.tab || !!this.cartStore.groupTab;
    this.orderApiService.removeNoItemsLocationsFromCheckout();
    this.route.params.subscribe((params) => {
      if (params.groupId) {
        this.groupId = params.groupId;
        this.getGroup();
        this.paymentStore.isGroupOrder = true;
        this.expandTip(this.tip.restaurant);
        this.expandTip(this.tip.driver);
      } else if (params.locationId) {
        if (this.restaurantStore.group) {
          sessionStorage.setItem('groupId', this.restaurantStore.group.groupId);
          if (this.route.snapshot.queryParams.customInstruction) {
            sessionStorage.setItem(UrlParam.customInstruction, decodeURIComponent(this.route.snapshot.queryParams.customInstruction));
          }
        }
        this.locationId = params.locationId;
        this.previousLocationId = this.locationId;
        this.getMerchant();
        this.getRestaurant();
        this.getRestaurantAvailableStatus();
        this.paymentStore.isGroupOrder = false;
        this.expandTip(this.tip.restaurant);
        this.expandTip(this.tip.driver);
      }
      this.getPromoCodeData();
    });
    this.initListeners();
    this.initKioskData();
    this.sharedOrderId = this.sharedOrderService.sharedOrderId$;
    this.getSharedOrders();
    this.orderApiService.calculateOrders();
  }

  private expandTip(tipType: Tip): void {
    if (tipType === Tip.driver && this.isShowDriverTip) {
      this.driverShowTipExpand = this.getGratuityPercent(this.tip.driver) === 0;
    } else if (tipType === Tip.restaurant && this.isShowRestaurantTip) {
      this.showTipsExpanded = this.getGratuityPercent(this.tip.restaurant) === 0;
    }
  }

  @HostListener('unloaded')
  ngOnDestroy() {
    this.destroyed$.next();
    this.resetDeliveryEstimate();
    this.paymentStore.selectedLoyaltyReward = null;
    this.tableNumberTouched = false;
    this.showTableNumberExpanded = false;
    this.fulfillmentTypeItems = [];
    this.paymentStore.setFulfilmentType(null);
    this.paymentStore.setEmail(null);
  }

  public updateHeaderLogo(e): void {
    this.isScrollStartPosition = e.detail.currentY === 0;
  }

  public showPaymentError(errorMessage: string): void {
    this.paymentErrorMessage = errorMessage;
  }

  public getFulfillmentItemIcon(locationItem: FulfillmentTypeItem): string {
    return `./assets/images/icons-sprite.svg#${locationItem.icon}`;
  }

  public setGroupKyooFee() {
    if (this.isDeliverySelected) {
      this.cartStore.kyooFee = this.group.deliveryKyooFee;
      this.cartStore.additionalKyooFee = this.group.deliveryAdditionalKyooFee;
    } else if ((this.isTableSideSelected && this.paymentStore.createTabChecked) || this.cartStore.groupTab) {
      this.cartStore.kyooFee = this.group.tabsKyooFee;
      this.cartStore.additionalKyooFee = this.group.tabsAdditionalKyooFee;
    } else {
      this.cartStore.kyooFee = this.group.kyooFee;
      this.cartStore.additionalKyooFee = this.group.additionalKyooFee;
    }
  }

  public preEstimateDelivery(): void {
    const address = this.paymentStore.deliveryAddress;
    if (!address || (address && (!address.street || !address.state || !address.city || !address.postalCode))) {
      return;
    }
    this.resetDeliveryEstimate();
    this.waitUntilDataLoad();
    const deliveryRequestData: DeliveryPreEstimateRequest = new DeliveryPreEstimateRequest(this.customerDeliveryAddress);
    if (!this.isGroup) {
      this.getDeliveryPreEstimate(this.locationId, deliveryRequestData);
    } else {
      this.getGroupDeliveryPreEstimate(this.groupId, deliveryRequestData);
    }
  }

  public estimateDelivery(): void {
    const deliveryRequestData = new DeliveryRequestData(
      this.customerDeliveryAddress,
      this.paymentStore.customer.phone,
      !this.cartStore.isAsap ? this.cartStore.deliveryAt : null,
      this.cartStore.totalPrice * 100
    );
    this.waitUntilDataLoad();
    if (!this.isGroup) {
      const orderMap = this.cartStore.orderMap[this.locationId];
      orderMap.isSubmitted = false;
      this.getDeliveryEstimate(this.locationId, deliveryRequestData);
    } else {
      this.getGroupDeliveryEstimate(this.groupId, deliveryRequestData);
    }
  }

  public getDeliveryPreEstimate(locationId: string, deliveryRequestData: DeliveryPreEstimateRequest): void {
    this.orderApiService
      .getDeliveryPreEstimate(locationId, deliveryRequestData)
      .pipe(filter(Boolean))
      .subscribe(
        (result: DeliveryPreEstimateResponseData) => {
          this.savePreEstimateDeliveryData(result);
        },
        (error) => {
          this.errorEstimateDeliveryData(error);
        }
      );
  }

  public getGroupDeliveryPreEstimate(groupId: string, deliveryRequestData: DeliveryPreEstimateRequest): void {
    deliveryRequestData.location_ids = this.groupRestaurants.map((restaurant) => restaurant.locationId);
    this.orderApiService
      .getGroupDeliveryPreEstimate(groupId, deliveryRequestData)
      .pipe(filter(Boolean))
      .subscribe(
        (result: DeliveryPreEstimateResponseData) => {
          this.savePreEstimateDeliveryData(result);
        },
        (error) => {
          this.errorEstimateDeliveryData(error);
        }
      );
  }

  public getDeliveryEstimate(locationId: string, deliveryRequestData: DeliveryRequestData): void {
    this.orderApiService
      .getDeliveryEstimate(locationId, deliveryRequestData)
      .pipe(filter(Boolean))
      .subscribe(
        (result: DeliveryResponseData) => {
          this.saveEstimateDeliveryData(result);
          this.deliveryType = result.delivery_type;
          this.expandTip(this.tip.restaurant);
          this.expandTip(this.tip.driver);
          this.orderApiService.calculateOrders();
        },
        (error) => {
          this.errorEstimateDeliveryData(error);
        }
      );
  }

  public getGroupDeliveryEstimate(groupId: string, deliveryRequestData: DeliveryRequestData): void {
    deliveryRequestData.location_ids = this.groupRestaurants.map((restaurant) => restaurant.locationId);
    this.orderApiService
      .getGroupDeliveryEstimate(groupId, deliveryRequestData)
      .pipe(filter(Boolean))
      .subscribe(
        (result: DeliveryResponseData) => {
          this.saveEstimateDeliveryData(result);
          this.deliveryType = result.delivery_type;
        },
        (error) => {
          this.errorEstimateDeliveryData(error);
        }
      );
  }

  public savePreEstimateDeliveryData(deliveryData: DeliveryPreEstimateResponseData): void {
    this.cartStore.deliveryDurationData = deliveryData;
    this.stopWaitingDataLoad();
    this.isWaitingDeliveryTime = true;
    this.isShowEstimateErrorMessage = false;
  }

  public saveEstimateDeliveryData(deliveryData: DeliveryResponseData): void {
    this.cartStore.deliveryResponseData = deliveryData;
    this.paymentStore.setDeliveryType(deliveryData.delivery_type === DeliveryType.SELLER ? DeliveryType.SELLER : DeliveryType.COURIER);
    this.isWaitingDeliveryTime = false;
    if (this.cartStore.deliveryResponseData.expires) {
      this.isEstimateHaveExpiresTime = true;
      this.setDeliveryCourierNotificationTimeout();
    }
    this.saveEstimatedDataPickupAt();
    this.stopWaitingDataLoad();
    this.isShowEstimateErrorMessage = false;
  }

  public saveEstimatedDataPickupAt(): void {
    const deliveryDuration = this.itemValidateService.convertLeadTimeToMinutes(this.cartStore.deliveryResponseData.duration);
    const pickupDuration = this.itemValidateService.convertLeadTimeToMinutes(this.cartStore.deliveryResponseData.pickup_duration);
    let pickupAt;
    if (this.cartStore.isAsap) {
      pickupAt = new Date();
      pickupAt.setMinutes(pickupAt.getMinutes() + pickupDuration);
    } else {
      pickupAt = new Date(this.cartStore.deliveryAt);
      pickupAt.setMinutes(pickupAt.getMinutes() - deliveryDuration + pickupDuration);
    }
    this.cartStore.pickupAt = pickupAt.toISOString();
  }

  public errorEstimateDeliveryData(error: any): void {
    this.isLoading = false;
    this.cartStore.deliveryResponseData = null;
    this.estimateErrorMessage = error.error.message ?? 'We had trouble finding that. Please make sure the address is valid.';
    this.isShowEstimateErrorMessage = true;
    this.isWaitingDeliveryTime = false;
    this.paymentStore.isWaitingUpdate = false;
  }

  public expiresTimeoutStop(event: any) {
    if (event.action === 'done') {
      this.isShowNotificationModal = true;
      this.isShowCountdown = false;
    }
  }

  public customerLoyaltyRewards(customer: Customer) {
    this.setCustomerLoyaltyRewards(customer);
  }

  private setDeliveryCourierNotificationTimeout() {
    const interval = moment(this.cartStore.deliveryResponseData.expires).diff(moment(new Date().toISOString()));
    this.countdownConfig.leftTime = interval / 1000;
    this.isShowCountdown = true;
    if (this.countdown) {
      this.countdown.restart();
    }
  }

  private updateMenuItemsValidations(): void {
    this.menuItemsValidations = [];
    for (const item of this.menuItemsInCart) {
      this.menuItemsValidations.push(new MenuItemVariationValidation(item, this.validateItem(item)));
    }
  }

  public titleCase(str: string) {
    return str
      .toLowerCase()
      .split(' ')
      .map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  public getAddress(): string {
    let address = '';
    const addressObject: RestaurantAddress = this.restaurant.address;
    const addressFields: string[] = ['addressLine', 'locality', 'state', 'postalCode'];
    for (const field of addressFields) {
      if (addressObject[field] != null) {
        address += field !== 'state' ? this.titleCase(addressObject[field]) : addressObject[field];
        address += addressObject[field].length > 0 && field !== 'state' && field !== 'postalCode' ? ',' : '';
        address += addressObject[field].length > 0 && field !== 'postalCode' ? ' ' : '';
      }
    }
    return (address = address.trim().endsWith(',') ? address.trim().slice(0, -1) : address.trim());
  }

  private getRestaurant() {
    this.restaurantStore
      .getRestaurantById(this.locationId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((restaurant) => {
        if (restaurant) {
          this.restaurant = restaurant;
          this.workHoursDaysInAdvance = this.formatDataService.generateWorkTimeInAdvance(
            this.restaurantStore.filteredWorkHours[restaurant.locationId],
            restaurant,
            this.pickupDaysInAdvance,
            this.restaurantStore.timeRangeParams
          );
          this.currencySign = this.restaurantStore?.restaurantCountryInfo?.currencySign;
          this.currency = this.restaurantStore.restaurantCountryInfo.currency;
          if (!this.cartStore.orderMap[this.locationId].order.is_additional_tab_round) {
            this.cartStore.kyooFee = restaurant.kyooFee;
          }
          this.cartStore.autoGratuityPercent = restaurant.autoGratuityPercent;
          this.cartStore.driverGratuityPercent = restaurant.defaultDeliveryAutoGratuityPercent;
          this.cartStore.enableRestaurantTips = restaurant.enableRestaurantTip;
          this.cartStore.tippingEnabled = restaurant.isTippingEnabled;
          this.cartStore.pickupLocation = this.getAddress();
          if (restaurant.allowScheduledPickups) {
            this.cartStore.printAheadDuration = this.restaurant.printAheadDuration;
            this.cartStore.pickupWindowDuration = this.restaurant.pickupWindowDuration;
            this.schedulePickupInvalid = false;
          } else {
            this.schedulePickupInvalid = false;
            this.cartStore.pickupAt = null;
            this.cartStore.printAheadDuration = null;
            this.cartStore.pickupWindowDuration = null;
          }
          if (restaurant.showTaxesAndFeesBreakout && !restaurant.displayKyooFeeOnMenu) {
            this.isShowInclusiveTaxesList = true;
            this.isShowExclusiveTaxesList = true;
          }
          this.paymentStore.loyaltyEnabled = restaurant.isLoyaltyEnabled;
        }
      });
  }

  private getGroup() {
    this.restaurantStore.group$.pipe(filter(Boolean)).subscribe((result: Group) => {
      this.group = result;
      this.setGroupKyooFee();
      this.cartStore.kyooFee = result.kyooFee;
      this.cartStore.tippingEnabled = result.tippingEnabled;
      this.restaurantStore
        .getRestaurants()
        .pipe(takeUntil(this.destroyed$), filter(Boolean))
        .subscribe((restaurants: Restaurant[]) => {
          this.groupRestaurants = this.setGroupRestaurants(restaurants);
          this.generateDataForRestaurantsInGroup();
          this.updateMenuItemsValidations();
        });
    });
  }

  private initKioskData(): void {
    if (this.restaurantStore.isKioskSmsOrder && this.restaurantStore.kioskSmsOrderData) {
      const kioskOrderFulfillment = this.restaurantStore.kioskSmsOrderData.fulfillmentType;
      const kioskOrderTableNumber = this.restaurantStore.kioskSmsOrderData.tableNumber;
      if (kioskOrderFulfillment === FulfillmentType.CURBSIDE) {
        this.selectedFulfillmentTypeItem = this.curbsideFulfillmentType;
      } else if (kioskOrderFulfillment === FulfillmentType.TABLESIDE) {
        this.selectedFulfillmentTypeItem = this.tablesideFulfillmentType;
        this.paymentStore.tableNumber = kioskOrderTableNumber;
      } else if (kioskOrderFulfillment === FulfillmentType.HANDOFF) {
        this.selectedFulfillmentTypeItem = this.handoffFulfillmentType;
        if (kioskOrderTableNumber) {
          this.paymentStore.tableNumber = kioskOrderTableNumber;
        }
      } else if (kioskOrderFulfillment === FulfillmentType.DELIVERY) {
        this.selectedFulfillmentTypeItem = this.deliveryFulfillmentType;
      } else {
        this.selectedFulfillmentTypeItem = this.pickupFulfillmentType;
      }
    }
  }

  private generateDataForRestaurantsInGroup() {
    this.restaurantsWorkHoursDaysInAdvance = [];
    this.groupRestaurantsFulfillment = [];
    for (const restaurant of this.groupRestaurants) {
      if (
        this.formatDataService.getIntervalFromDuration(this.cartStore.pickupWindowDuration) >
        this.formatDataService.getIntervalFromDuration(restaurant.pickupWindowDuration)
      ) {
        this.cartStore.pickupWindowDuration = restaurant.pickupWindowDuration;
      }
      const filteredWorkHours = this.restaurantStore.filteredWorkHours[restaurant.locationId];
      this.restaurantsWorkHoursDaysInAdvance.push(
        this.formatDataService
          .generateWorkTimeInAdvance(filteredWorkHours, restaurant, Number(restaurant.pickupDaysInAdvance), this.restaurantStore.timeRangeParams)
          .splice(0, Number(restaurant.pickupDaysInAdvance))
      );
      this.groupRestaurantsFulfillment.push(this.generateFulfillmentTypeItems(restaurant.availableStatus, restaurant));
    }
    this.workHoursDaysInAdvance = this.formatDataService.generateGroupWorkTime(this.restaurantsWorkHoursDaysInAdvance);
    if (this.paymentStore.tableNumber && this.paymentStore.isLinkTableNumber) {
      this.fulfillmentTypeItems = [];
      this.fulfillmentTypeItems.push(this.tablesideFulfillmentType);
    } else {
      this.fulfillmentTypeItems = this.generateGroupFulfillment();
    }
    this.selectedFulfillmentTypeItem = this.fulfillmentTypeItems[0];
  }

  public selectDeliveryAddress(address: DeliveryAddress): void {
    this.deliveryAddress = {
      street: address.street,
      suite: address.suite,
      city: address.city,
      state: address.state,
      postalCode: address.postalCode,
      instructions: address.instructions,
    };
    this.changeDeliveryAddress();
    this.preEstimateDelivery();
  }

  private getCustomerAddresses(): void {
    if (this.selectedFulfillmentTypeItem?.type !== 'delivery') {
      return;
    }
    this.customerAddresses = [];
    this.paymentStore.deliveryAddress = null;
    this.deliveryAddress = new DeliveryAddress('', '', '', '', '', '');
    if (this.paymentStore.customer) {
      this.paymentStore.isWaitingUpdate = true;
      this.orderApiService.getCustomerAddresses(this.paymentStore.customer.orderBotUserId).subscribe(
        (addresses: Address[]) => {
          if (addresses.length === 1) {
            const { address, suite, city, state, postal_code } = addresses[0];
            this.paymentStore.deliveryAddress = new DeliveryAddress(address, suite, city, state, postal_code, '');
            this.deliveryAddress = this.paymentStore.deliveryAddress;
            this.saveDeliveryAddress = true;
          } else if (addresses.length > 1) {
            for (const customerAddress of addresses) {
              const { address, suite, city, state, postal_code } = customerAddress;
              this.customerAddresses.push(new DeliveryAddress(address, suite, city, state, postal_code, ''));
            }
            this.paymentStore.deliveryAddress = this.customerAddresses[0];
            this.deliveryAddress = this.customerAddresses[0];
            this.saveDeliveryAddress = true;
          }
          if (this.isDeliverySelected) {
            this.preEstimateDelivery();
          }
          this.paymentStore.isWaitingUpdate = false;
        },
        () => {
          this.paymentStore.isWaitingUpdate = false;
        }
      );
    }
  }

  private saveCustomerAddress(): void {
    if (this.isDeliverySelected && this.paymentStore.saveDeliveryAddress) {
      this.orderApiService.saveCustomerAddress(this.paymentStore.customer.orderBotUserId, this.customerDeliveryAddress).subscribe(
        () => {
          this.paymentStore.deliveryAddress = null;
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }
  private updateCustomer(name: string, surname: string, email: string, address: BillingAddress): void {
    if (this.isTab) {
      return;
    }
    const customerData = {
      given_name: name,
      family_name: surname,
      email_address: email,
      address: address,
    };
    this.orderApiService.saveCustomer(this.paymentStore.customer.orderBotUserId, customerData).subscribe();
  }

  private getRestaurantAvailableStatus(): void {
    this.restaurantStore.restaurantAvailableStatus$
      .pipe(filter(Boolean), takeUntil(this.destroyed$))
      .subscribe((restaurantAvailableStatus: RestaurantAvailableStatus) => {
        this.availableRestaurant = restaurantAvailableStatus;
        this.estimatedTimeInMinutes = this.leadTimeService.convertLeadTimeToMinutes(restaurantAvailableStatus.estimatedTimeToBeginPreparation);
        this.hideETA = restaurantAvailableStatus.hideETA;
        this.fulfillmentTypeItems = this.generateFulfillmentTypeItems(restaurantAvailableStatus, this.restaurant);
        if (this.paymentStore.tableNumber && !this.isRestaurantClosed && this.paymentStore.isLinkTableNumber) {
          this.fulfillmentTypeItems = [];
          this.fulfillmentTypeItems.push(this.tablesideFulfillmentType);
          this.selectedFulfillmentTypeItem = this.tablesideFulfillmentType;
        } else if (this.paymentStore.tableNumber && !this.isRestaurantClosed) {
          this.selectedFulfillmentTypeItem = this.tablesideFulfillmentType;
        } else if (this.fulfillmentTypeItems.length) {
          // } else if (this.fulfillmentTypeItems.length && (this.restaurant.autoSelectFulfillment || this.fulfillmentTypeItems.length === 1)) {
          this.selectedFulfillmentTypeItem = this.fulfillmentTypeItems[0];
        }
        this.paymentStore.setFulfilmentType(this.selectedFulfillmentTypeItem.type);
      });
    this.updateMenuItemsValidations();
  }

  private generateFulfillmentTypeItems(
    {
      isCurbsideEnabled,
      isTablesideEnabled,
      isPickupEnabled,
      isDeliveryEnabled,
      isXSideEnabled,
      isFridgeEnabled,
      handoffLocation,
      deliverySeller,
      deliveryCourier,
      deliverySellerMinAmount,
      deliveryCourierMinAmount,
    }: RestaurantAvailableStatus,
    restaurant: Restaurant
  ): FulfillmentTypeItem[] {
    const fulfillmentTypeItems = [];
    if (this.isSubscriptionCheckout) {
      this.pickupFulfillmentType.minAmount = restaurant.minMaxRestrictions.pickup.minimum;
      this.pickupFulfillmentType.maxAmount = restaurant.minMaxRestrictions.pickup.maximum;
      fulfillmentTypeItems.push(this.pickupFulfillmentType);
      return fulfillmentTypeItems;
    }
    if (this.checkFulfillmentForRestaurant('Pickup') || this.checkFulfillmentForGroup(isPickupEnabled)) {
      this.pickupFulfillmentType.minAmount = restaurant.minMaxRestrictions.pickup.minimum;
      this.pickupFulfillmentType.maxAmount = restaurant.minMaxRestrictions.pickup.maximum;
      fulfillmentTypeItems.push(this.pickupFulfillmentType);
    }
    if (this.checkFulfillmentForRestaurant('Curbside') || this.checkFulfillmentForGroup(isCurbsideEnabled)) {
      this.curbsideFulfillmentType.minAmount = restaurant.minMaxRestrictions.curbside.minimum;
      this.curbsideFulfillmentType.maxAmount = restaurant.minMaxRestrictions.curbside.maximum;
      fulfillmentTypeItems.push(this.curbsideFulfillmentType);
    }
    if (this.checkFulfillmentForRestaurant('Tableside') || this.checkFulfillmentForGroup(isTablesideEnabled)) {
      this.tablesideFulfillmentType.minAmount = restaurant.minMaxRestrictions.tableside.minimum;
      this.tablesideFulfillmentType.maxAmount = restaurant.minMaxRestrictions.tableside.maximum;
      fulfillmentTypeItems.push(this.tablesideFulfillmentType);
    }
    if (this.checkFulfillmentForRestaurant('Delivery') || this.checkFulfillmentForGroup(isDeliveryEnabled)) {
      fulfillmentTypeItems.push(this.deliveryFulfillmentType);
      if (deliverySeller) {
        this.isGroup
          ? fulfillmentTypeItems.push({
            title: 'Seller',
            icon: '',
            type: DeliveryType.SELLER,
            minAmount: restaurant.minMaxRestrictions.delivery.minimum,
            maxAmount: restaurant.minMaxRestrictions.delivery.maximum
          })
          : this.deliveryTypeItems.push({
            title: 'Seller',
            icon: '',
            type: DeliveryType.SELLER,
            minAmount: restaurant.minMaxRestrictions.delivery.minimum,
            maxAmount: restaurant.minMaxRestrictions.delivery.maximum
          });
      }
      if (deliveryCourier) {
        this.isGroup
          ? fulfillmentTypeItems.push({ title: 'Courier', icon: '', type: DeliveryType.COURIER, minAmount: deliveryCourierMinAmount })
          : this.deliveryTypeItems.push({ title: 'Courier', icon: '', type: DeliveryType.COURIER, minAmount: deliveryCourierMinAmount });
      }
    }
    if (this.checkFulfillmentForRestaurant('X-Side') || this.checkFulfillmentForGroup(isXSideEnabled)) {
      if (handoffLocation) {
        this.handoffLocationNumbered = restaurant.handoffLocationNumbered;
        const handoffTitle = handoffLocation;
        fulfillmentTypeItems.push({
          title: handoffTitle,
          icon: `icon-${handoffLocation.toLowerCase()}side`,
          type: FulfillmentType.HANDOFF,
          minAmount: restaurant.minMaxRestrictions.handoff.minimum,
          maxAmount: restaurant.minMaxRestrictions.handoff.maximum,
        });
      }
    }
    if (this.checkFulfillmentForRestaurant('Fridge')) {
      fulfillmentTypeItems.push(this.fridgeFulfillmentType);
    }
    if (this.isGroup && !isPickupEnabled && !isCurbsideEnabled && !isTablesideEnabled && !isXSideEnabled && !isFridgeEnabled) {
      this.pickupFulfillmentType.minAmount = restaurant.minMaxRestrictions.pickup.minimum;
      this.pickupFulfillmentType.maxAmount = restaurant.minMaxRestrictions.pickup.maximum;
      fulfillmentTypeItems.push(this.pickupFulfillmentType);
    }
    return fulfillmentTypeItems;
  }

  private checkFulfillmentForRestaurant(fulfillmentType: string) {
    if (this.restaurantStore.timeRangeParams && fulfillmentType === 'Tableside') {
      return (
        !this.isGroup &&
        this.restaurantStore.enabledFulfillments.includes(fulfillmentType) &&
        this.formatDataService.isTimeNowInWorkRange(this.workHoursDaysInAdvance[0])
      );
    }
    return !this.isGroup && this.restaurantStore.enabledFulfillments.includes(fulfillmentType);
  }

  private checkFulfillmentForGroup(fulfillmentEnabled: boolean) {
    return this.isGroup && fulfillmentEnabled;
  }

  private setGroupRestaurants(restaurants: Restaurant[]): Restaurant[] {
    const groupRestaurants = [];
    for (const restaurant of restaurants) {
      if (this.isRestaurantItemInCart(restaurant.locationId)) {
        groupRestaurants.push(restaurant);
        const estimatedTime = this.leadTimeService.convertLeadTimeToMinutes(restaurant.estimatedTimeToBeginPreparation);
        if (!this.estimatedTimeInMinutes || this.estimatedTimeInMinutes < estimatedTime) {
          this.estimatedTimeInMinutes = estimatedTime;
        }
        if (!this.hideETA) {
          this.hideETA = restaurant.hideETA;
        }
      }
    }
    this.cartStore.ordersInGroup = groupRestaurants.length;
    return groupRestaurants;
  }

  private generateGroupFulfillment(): FulfillmentTypeItem[] {
    const fulfillmentTypeItems = [];
    const deliveryTypeItems = [];
    if (this.isFulfillmentInRestaurants(FulfillmentType.PICKUP)) {
      fulfillmentTypeItems.push(this.pickupFulfillmentType);
    }
    if (this.isFulfillmentInRestaurants(FulfillmentType.CURBSIDE)) {
      fulfillmentTypeItems.push(this.curbsideFulfillmentType);
    }
    if (this.isFulfillmentInRestaurants(FulfillmentType.TABLESIDE)) {
      fulfillmentTypeItems.push(this.tablesideFulfillmentType);
    }
    if (this.isFulfillmentInRestaurants(FulfillmentType.DELIVERY) && (this.group.courierDeliveryEnabled || this.group.sellerDeliveryEnabled)) {
      if (this.isDeliveryInRestaurants(DeliveryType.SELLER) && this.group.sellerDeliveryEnabled) {
        deliveryTypeItems.push({
          title: 'Seller',
          icon: '',
          type: DeliveryType.SELLER,
          minAmount: this.getMaxMinAmountOfGroupDeliveryType(DeliveryType.SELLER),
        });
      }
      if (this.isDeliveryInRestaurants(DeliveryType.COURIER) && this.group.courierDeliveryEnabled) {
        deliveryTypeItems.push({
          title: 'Courier',
          icon: '',
          type: DeliveryType.COURIER,
          minAmount: this.getMaxMinAmountOfGroupDeliveryType(DeliveryType.COURIER),
        });
      }
      if (deliveryTypeItems.length !== 0) {
        fulfillmentTypeItems.push(this.deliveryFulfillmentType);
        this.deliveryTypeItems = deliveryTypeItems;
      }
    }
    if (fulfillmentTypeItems.length === 0) {
      fulfillmentTypeItems.push(this.pickupFulfillmentType);
    }
    return fulfillmentTypeItems;
  }

  private isFulfillmentInRestaurants(fulfillmentType: FulfillmentType): boolean {
    if (this.restaurantStore.fulfillmentParams.length !== 0) {
      return !!this.groupRestaurantsFulfillment.find((fulfillments: FulfillmentTypeItem[]) =>
        fulfillments.find((fulfillment) => fulfillment.type === fulfillmentType && this.restaurantStore.fulfillmentParams.includes(fulfillmentType))
      );
    }
    return !!this.groupRestaurantsFulfillment.find((fulfillments: FulfillmentTypeItem[]) =>
      fulfillments.find((fulfillment) => fulfillment.type === fulfillmentType)
    );
  }

  private isDeliveryInRestaurants(deliveryType: DeliveryType): boolean {
    const restaurantsWithDeliveryType = this.groupRestaurantsFulfillment.filter((fulfillments: DeliveryTypeItem[]) =>
      fulfillments.find((fulfillment) => fulfillment.type === deliveryType)
    );
    if (!restaurantsWithDeliveryType) {
      return false;
    }
    return this.groupRestaurantsFulfillment.length === restaurantsWithDeliveryType.length;
  }

  private getMaxMinAmountOfGroupDeliveryType(type: DeliveryType): number {
    let maxMinAmount = 0;
    for (const restaurantFulfillment of this.groupRestaurantsFulfillment) {
      for (const fulfillment of restaurantFulfillment) {
        if (type === fulfillment.type && maxMinAmount < fulfillment.minAmount) {
          maxMinAmount = fulfillment.minAmount;
        }
      }
    }
    return maxMinAmount;
  }

  private resetDeliveryEstimate(): void {
    this.isShowEstimateErrorMessage = false;
    this.isWaitingDeliveryTime = false;
    this.paymentErrorMessage = null;
    this.cartStore.deliveryResponseData = null;
    this.cartStore.deliveryDurationData = null;
    this.cartStore.deliveryAt = null;
  }

  public calculateGratuityPercent(price: number): number {
    return this.cartStore.totalPrice !== 0
      ? parseInt(((100 * price) / (this.cartStore.totalPrice + this.cartStore.totalDiscountsPrice)).toString(), 10)
      : this.cartStore.totalPrice;
  }

  public getFormattedPrice(price: string | number, quantity = 1): string {
    return (+price * quantity).toFixed(2);
  }

  public getFormattedAddress(address: DeliveryAddress): string {
    if (address.suite && address.street && address.city) {
      return address.suite + ' ' + address.street + ', ' + address.city;
    } else if (address.street && address.city) {
      return address.street + ', ' + address.city;
    } else {
      return address.street;
    }
  }

  public percentageToNumber(percent: string): number {
    return Number(percent);
  }

  public onFocusInTableNumber(): void {
    this.showTableNumberExpanded = true;
  }

  public onFocusOutTableNumber(): void {
    this.tableNumberTouched = true;
  }

  public changeSaveAddressValue(checked: boolean): void {
    this.paymentStore.saveDeliveryAddress = checked;
  }

  public changeUseLoyaltyPoints(checked: boolean): void {
    this.paymentStore.useLoyaltyChecked = checked;
    this.paymentStore.selectedLoyaltyReward = checked ? this.filteredLoyaltyRewards[0] : null;
    if (checked) {
      this.orderApiService.calculateOrders();
    }
  }

  public selectLoyaltyReward(loyaltyReward: LoyaltyRewardTier): void {
    this.paymentStore.selectedLoyaltyReward = loyaltyReward;
    this.orderApiService.calculateOrders();
  }

  public changeDeliveryAddress(): void {
    this.paymentStore.deliveryAddress = {
      street: this.deliveryAddress.street,
      suite: this.deliveryAddress.suite === '' ? null : this.deliveryAddress.suite,
      city: this.deliveryAddress.city,
      state: this.deliveryAddress.state,
      postalCode: this.deliveryAddress.postalCode,
      instructions: this.deliveryAddress.instructions === '' ? null : this.deliveryAddress.instructions,
    };
  }

  public editItem(index: number) {
    this.selectedItemIndex = index;
    this.waitUntilDataLoad();
    this.selectedCartProduct = this.cartStore.items[index];
    if (this.isGroup) {
      this.editedProductRestaurant = this.restaurantStore.findLocationById(this.groupRestaurants, this.selectedCartProduct.locationId);
      this.restaurantStore.getRestaurantFulfillment(this.editedProductRestaurant);
    }
    for (const products of this.restaurantStore.curProducts) {
      for (const product of products) {
        if (this.selectedCartProduct.itemId === product.info.id) {
          this.selectedProduct = product;
          const variationIdList = [];
          for (const variation of product.variations) {
            if (variation.trackInventory) {
              variationIdList.push(variation.id);
            }
          }
          if (variationIdList.length > 0) {
            let merchantId = null;
            if (this.isGroup) {
              merchantId = this.restaurantStore.findLocationById(this.groupRestaurants, this.selectedCartProduct.locationId).merchantId;
            }
            this.restaurantService
              .getRestaurantInventoryData(this.selectedCartProduct.locationId, variationIdList, merchantId)
              .subscribe((variationList: VariationInventoryInfo[]) => {
                for (const itemVariation of product.variations) {
                  const variationInfo = variationList.find((variation) => variation.catalog_object_id === itemVariation.id);
                  if (variationInfo) {
                    itemVariation.quantityRemaining = Number(variationInfo.quantity);
                  }
                }
                this.isLoading = false;
                !this.isMobile ? (this.isShowProductModal = true) : this.createModal();
              });
          } else {
            this.isLoading = false;
            !this.isMobile ? (this.isShowProductModal = true) : this.createModal();
          }
        }
      }
    }
    if (this.selectedCartProduct.isService) {
      this.isLoading = false;
      this.selectedProduct = this.itemService.itemServiceProduct;
      !this.isMobile ? (this.isShowProductModal = true) : this.createModal();
    }
  }

  public async deliveryPickUpDateTime() {
    const clientRect = this.deliveryTimepicker.nativeElement.getBoundingClientRect();
    const deliveryDuration = this.itemValidateService.convertLeadTimeToMinutes(this.cartStore.deliveryDurationData.duration);
    const daysInAdvance = this.restaurantStore.timeRangeParams != null ? this.workHoursDaysInAdvance.length : this.pickupDaysInAdvance;
    const deliveryInterval = deliveryDuration ? Math.round(deliveryDuration) : 30;
    const initialDate = new DateTime(new Date());

    const event: any = { target: { getBoundingClientRect: () => clientRect } };
    const popover = await this.popoverController.create({
      component: PickUpDateTimeComponent,
      componentProps: {
        hoursOfOperation: this.workHoursDaysInAdvance,
        initialDate: initialDate.date,
        initialTimeInterval: initialDate.timeInterval,
        interval: this.interval,
        deliveryInterval: deliveryInterval,
        asap: true,
        isDelivery: true,
        disableASAP: false,
        selectASAP: true,
        acceptingOrders: !this.isRestaurantClosed,
        pickupDaysInAdvance: daysInAdvance,
        estimatedTimeInMinutes: deliveryInterval,
        showWindowEndTime: !(this.isCityFlavor && this.isDeliverySelected),
        isCityFlavor: this.isCityFlavor,
        isFlavorShifts: this.merchant && this.merchant.useFlavorShiftsTime,
        selectedDeliveryLocation: this.selectedDeliveryLocation,
        locationId: this.locationId,
        useFlavorShifts: this.merchant.useFlavorShiftsTime,
        shifts: this.shifts
      },
      showBackdrop: false,
      event: event,
      cssClass: 'select-date-time-popover',
    });

    this.isDateTimeModalOpen = true;

    popover.onDidDismiss().then(({ data }) => {
      this.isDateTimeModalOpen = false;
      if (data) {
        const { dateTime } = data;
        if (dateTime && dateTime.timeInterval) {
          this.cartStore.deliveryAt = dateTime.timeInterval.start.toISOString();
          this.cartStore.isAsap = false;
        } else {
          this.cartStore.deliveryAt = 'asap';
          this.cartStore.isAsap = true;
        }
        this.estimateDelivery();
      }
    });

    return await popover.present().then(() => {
      setTimeout(() => {
        const backgrounds = document.getElementsByTagName('ion-backdrop');
        if (backgrounds.length === 1) {
          backgrounds[0].addEventListener('click', function() {
            popover.dismiss();
          });
        }
      }, 300);
    });
  }

  public get showWindowEndTime(): boolean {
    return this.restaurant ? this.restaurant.showWindowEndTime : true;
  }

  public get showTimeBasedErrorMessage(): boolean {
    if (this.isTab) {
      return false;
    }
    return this.forceTouched || (this.cartStore.pickupAt != null && this.cartStore.isAsap != null);
  }

  public get pickupDateTimeLabelText(): string {
    if (this.isSkybox) {
      return 'Pre-Order Date';
    }
    if (this.interval < 60 * 24) {
      return 'Pick up time';
    } else {
      return 'Pick up date';
    }
  }

  public get pickupDateTimeDescriptionText(): string {
    if (this.isHidePickupTime) {
      return 'Time to pick up your order'
    }
    if (this.isSkybox) {
      return 'Select a pre-order time';
    }
    if (this.interval < 60 * 24) {
      return 'Select a time to pick up your order';
    } else {
      return 'Select a day to pick up your order';
    }
  }

  public formatIsoString(date: string) {
    const deliveryDate = new Date(date);
    const datePart = deliveryDate.toDateString() === new Date().toDateString() ? 'Today' : this.datePipe.transform(deliveryDate, 'EEE');
    const timePart = this.lowerCasePipe.transform(this.datePipe.transform(deliveryDate, 'h:mma'));
    return timePart ? `${datePart} - ${timePart}` : datePart;
  }

  public async createModal() {
    const modal = await this.modalController.create({
      component: ProductModalComponent,
      componentProps: {
        restaurant: this.selectedLocation,
        defaultProduct: this.selectedProduct,
        cartProduct: this.selectedCartProduct,
        locationId: this.selectedLocation.locationId,
        taxes: this.taxes,
        isClosed: this.isRestaurantClosed,
        isModal: false,
        allowScheduledPickups: this.selectedLocation.allowScheduledPickups,
        isMobileEnabled: this.selectedLocation.isMobileEnabled,
        enforceInventory: this.selectedLocation.enforceInventory,
        hoursOfOperation: this.selectedLocation.hoursOfOperation,
        currencySign: this.restaurantStore.restaurantCountryInfo.currencySign,
        isEdited: true,
        isRestaurantHaveEnabledWorkDays: true,
      },
    });

    modal.onDidDismiss().then((data) => {
      const item = data['data'] ? data['data'].cartProduct : null;
      if (item) {
        this.onEditItemToCart(item);
      } else {
        this.paymentStore.isWaitingUpdate = false;
      }
      this.currentModal = null;
    });
    await modal.present();
    this.currentModal = modal;
  }

  public saveCustomerData(token: string): void {
    this.token = token;
    this.cookieService.set('phoneNumber', this.paymentStore.customer.phone);
    this.getCustomerAddresses();
    this.saveCustomerToStorage();
  }

  public authoriseCustomer(token: string): void {
    this.phoneInvalid = false;
    this.saveCustomerData(token);
    if (this.platform.is(Platforms.CORDOVA) && !this.isStoneCreek) {
      this.showPhoneNumber = false;
    }
  }

  public deleteItemFromCart(i: number) {
    this.paymentStore.isWaitingUpdate = true;
    this.paymentStore.selectedLoyaltyReward = null;
    if (this.isGroup) {
      this.orderApiService.deleteItemFromOrderMap(i, this.createMerchantUrl(this.cartStore.items[i].locationId));
      this.groupRestaurants = this.setGroupRestaurants(this.groupRestaurants);
      this.generateDataForRestaurantsInGroup();
    } else {
      this.orderApiService.deleteItemFromOrderMap(i);
    }
    this.updateMenuItemsValidations();
    if (!this.cartStore.items.length) {
      location.reload();
    }
    if (this.paymentStore.customer && this.paymentStore.customer?.loyaltyRewardsTier) {
      this.paymentStore.selectedLoyaltyReward = null;
      if (this.cartStore.cartItems.length === 0) {
        this.filteredLoyaltyRewards = [];
        this.cartStore.loyalty = null;
        return;
      }
      this.setCustomerLoyaltyRewards(this.paymentStore.customer);
    }
    this.checkIfNeedEstimate();
  }

  public closeProductModal(): void {
    this.isShowProductModal = false;
    this.selectedProduct = null;
    this.selectedCartProduct = null;
  }

  public expandTips(tipType: Tip): any {
    switch (tipType) {
      case Tip.restaurant: return this.showTipsExpanded = true;
      case Tip.driver: return this.driverShowTipExpand = true;
    }
  }

  public onEditItemToCart(item: MenuItemForPayment): void {
    if (this.cartStore.findCartItemIndex(item) !== this.selectedItemIndex) {
      this.cartStore.deleteItemFromCart(this.selectedItemIndex);
      this.cartStore.addItemToCart(item);
    } else {
      this.cartStore.replaceCartItem(this.selectedItemIndex, item);
    }
    this.closeProductModal();
    this.updateMenuItemsValidations();
    if (this.isGroup) {
      const order = this.orderApiService.getOrderWithTipMoney(item.locationId);
      this.calculateGroupOrder(item.locationId, order);
    } else {
      this.orderApiService.calculateOrders();
    }
    if (this.paymentStore.customer && this.paymentStore.customer?.loyaltyRewardsTier) {
      this.setCustomerLoyaltyRewards(this.paymentStore.customer);
    }
    this.checkIfNeedEstimate();
  }

  public allowCreateTab(checked: boolean): void {
    this.tabOptionSelected = true;
    if (this.paymentStore.createTabChecked === checked) {
      return;
    }
    if (this.isGroup && this.groupRestaurants.length > 0) {
      this.paymentStore.createTabChecked = checked && !this.groupRestaurants.find((restaurant) => !restaurant.isTabsEnabled);
      this.setGroupKyooFee();
    } else {
      this.paymentStore.createTabChecked = checked && this.restaurant.isTabsEnabled;
      this.paymentStore.useLoyaltyChecked = !checked;
      this.paymentStore.selectedLoyaltyReward =
        !checked && this.filteredLoyaltyRewards && this.filteredLoyaltyRewards.length ? this.filteredLoyaltyRewards[0] : null;
      this.orderApiService.calculateOrders();
    }
    if (this.paymentStore.createTabChecked && this.restaurantStore.group) {
      if (this.paymentStore.customer && !this.paymentStore.customer.isShared) {
        this.isNeedSharingPhoneNumber = true;
        this.restaurantStore.updatePhoneNumber = true;
      }
    } else if (!this.paymentStore.createTabChecked && this.restaurantStore.group) {
      if (this.paymentStore.customer && !this.paymentStore.customer.isShared) {
        this.isNeedSharingPhoneNumber = false;
        this.restaurantStore.updatePhoneNumber = true;
      }
    } else {
      this.isNeedSharingPhoneNumber = false;
    }
  }

  public onWalletTouched(event: Event): void {
    this.forceTouched = true;
    if (this.invalid) {
      const firstInvalidField = this.findFirstInvalidField();
      if (firstInvalidField) {
        this.content.scrollToPoint(0, firstInvalidField.nativeElement.offsetTop, 300);
      }
    }
  }

  public async submit(): Promise<void> {
    if (this.sharedOrderId) {
      if (!this.paymentStore.givenName || !this.paymentStore.familyName) {
        this.forceTouched = true;
        const firstInvalidField = this.findFirstInvalidField();
        if (firstInvalidField) {
          this.content.scrollToPoint(0, firstInvalidField.nativeElement.offsetTop, 300);
        }
        return;
      }
      this.isLoading = true;
      this.sharedOrderService.addToSharedOrder(this.restaurant.locationId).subscribe(response => {
        this.isLoading = false;
        this.successPayment();
      }, () => {
        this.isLoading = false;
      });
      return;
    }
    if (this.isStoneCreek && !this.userVerified) {
      if (!await this.savePaymentDetailsAlert()) {
        return;
      }
    }
    if (!this.userVerified && this.restaurant && this.restaurant?.requirePhoneVerification) {
      this.paymentErrorMessage = 'Phone verification required';
      return;
    }
    this.paymentErrorMessage = null;
    if (this.invalid) {
      this.forceTouched = true;
      const firstInvalidField = this.findFirstInvalidField();
      if (firstInvalidField) {
        this.content.scrollToPoint(0, firstInvalidField.nativeElement.offsetTop, 300);
      }
      return;
    }
    if (this.isSubscriptionCheckout) {
      this.cartStore.isAsap = false;
      const selectedPlan = this.cartStore.subscriptionsData.find((phase) => phase.selected);
      if (selectedPlan && selectedPlan.selected) {
        const selectedDays = this.isCadenceEqualsValue('daily')
          ? null
          : this.daysToSelect
            .map((day) => {
              if (day.selected) return day.value;
            })
            .filter((value) => value != null);
        const selectedPeriods = this.isCadenceEqualsValue('monthly')
          ? selectedPlan.selectedPeriods
            .map((period) => {
              if (period.selected) return period.value;
            })
            .filter((value) => value != null)
          : null;
        this.paymentStore.createSubscriptionData = new CreateSubscriptionData(
          selectedPlan.subscriptionId,
          selectedPlan.cadence,
          selectedDays,
          this.locationId,
          selectedPeriods
        );
      }
    }
    this.paymentStore.setStatePayment(StatePayment.SEND);
  }

  public notificationModalClosed(): void {
    this.isShowNotificationModal = false;
    this.estimateDelivery();
  }

  public cancel() {
    this.promoCode = null;
    this.discountService.removeDiscountFromStorage();
    this.cartStore.discounts = [];
    this.paymentStore.applyPromoCodeState = ApplyPromoCodeProcess.INIT;
    this.cartStore.setCoupons([]);
    this.cartStore.deleteItemsFromCartByLocationId(this.locationId);
    this.saveCustomerToStorage();
    this.restaurantStore.backToStorePage(true);
  }

  public addOrdersToTab(): void {
    if (!this.checkItemsValid && this.showTimeBasedErrorMessage) {
      return;
    }
    this.isLoading = true;
    if (this.cartStore.tab) {
      const locationsIds = Object.keys(this.cartStore.orderMap);
      for (const locationId of locationsIds) {
        if (!this.cartStore.orderMap[locationId].isPaid) {
          this.updateOrder(locationId);
        }
      }
    } else if (this.cartStore.groupTab) {
      this.addOrderToGroupTab();
    }
  }

  public updateOrder(locationId: string): void {
    const orderMap = this.cartStore.orderMap[locationId];
    const order = this.orderApiService.getOrderWithTipMoney(locationId);
    order.is_tab_order = true;
    order.fulfillment_type = FulfillmentType.TABLESIDE;
    order.is_additional_tab_round = true;
    this.orderApiService.updateOrder(locationId, orderMap.id, order).subscribe(
      ({ total_money, taxes, discounts, accumulated_loyalty_points, line_items, estimated_duration }: any) => {
        this.orderApiService.updateOrderData(locationId, order, orderMap, total_money, taxes, discounts, accumulated_loyalty_points, line_items, estimated_duration);
        this.addOrderToTab(locationId, orderMap.id);
      },
      error => {
        this.tabError = true;
        this.tabErrorMessage = error?.error?.message;
        this.tabError = true;
        this.paymentStore.isWaitingUpdate = false;
      }
    );
  }

  public updateIconOrder(): void {
    this.orderApiService.calculateSingleOrder(this.locationId);
  }

  private addOrderToTab(locationId: string, orderId: string): void {
    if (!this.isUpdatingTab) {
      this.isUpdatingTab = true;
      this.orderApiService.updateTab(locationId, orderId, this.cartStore.tab.tab_id).subscribe(
        (tab: OrderTab) => {
          this.cartStore.orderMap[locationId].isPaid = true;
          this.cartStore.tab = tab;
          this.addNextOrderToTab();
        },
        error => {
          this.tabError = true;
          this.tabErrorMessage = error?.error?.message;
          this.isUpdatingTab = false;
          this.isLoading = false;
        }
      );
    } else {
      this.tabUpdateQueue.push({ locationId, orderId });
    }
  }

  private addOrderToGroupTab(): void {
    this.isUpdatingTab = true;
    const groupTab = this.cartStore.groupTab;
    const groupOrder = this.orderApiService.createGroupOrder(this.groupRestaurants);
    const customOrderNumber = sessionStorage.getItem(UrlParam.customInstruction);
    if (customOrderNumber) {
      groupOrder.custom_number = customOrderNumber;
    }
    this.orderApiService.updateGroupTab(groupTab.group_id, groupTab.group_order_id, groupOrder.createOrderRequest).subscribe(
      (tab: GroupOrderTab) => {
        this.cartStore.groupTab = tab;
        this.isLoading = false;
        this.paymentStore.setStatePayment(StatePayment.SUCCESS);
      },
      error => {
        this.tabError = true;
        this.tabErrorMessage = error?.error?.message;
        this.isUpdatingTab = false;
        this.isLoading = false;
      }
    );
  }

  private addNextOrderToTab() {
    this.isUpdatingTab = false;
    if (this.tabUpdateQueue.length !== 0) {
      const { locationId, orderId } = this.tabUpdateQueue.shift();
      this.addOrderToTab(locationId, orderId);
    } else {
      this.cartStore.clearCartAndOrderMap();
      this.isLoading = false;
      this.paymentStore.setStatePayment(StatePayment.SUCCESS);
    }
  }

  public addOrderAndCloseTab() {
    this.isNavigateToCloseTab = true;
    this.addOrdersToTab();
  }

  private calculateGroupOrder(locationId: string, order: Order): void {
    const orderMap = this.cartStore.orderMap[locationId];
    this.orderApiService
      .calculateOrder(locationId, order, this.createMerchantUrl(locationId))
      .subscribe(({ total_money, taxes, discounts, accumulated_loyalty_points, line_items, estimated_duration }: any) => {
        const totalPrice = total_money.amount - this.cartStore.taxesSum(taxes);
        this.cartStore.updateOrderMapData(locationId, order, totalPrice, taxes, discounts, accumulated_loyalty_points, line_items, estimated_duration);
        this.paymentStore.isWaitingUpdate = false;
        this.cartStore.updateCartInProgress = false;
      });
  }

  public openLink(link: string) {
    const newTab = window.open(link, '_blank');
    newTab.focus();
  }

  public get showPromoCodeField(): boolean {
    if (this.isGroup) {
      return false;
    }
    return this.isShowPromoCodeField && this.restaurant?.showPromoCodeField;
  }

  public get switchPromoCodeText(): string {
    if (this.showPromoCodeField) {
      return 'Hide promo code';
    }
    return '+ promo code';
  }

  public get applyPromoCodeText(): string {
    if (this.paymentStore.applyPromoCodeState === ApplyPromoCodeProcess.SUCCESS) {
      return 'applied';
    }
    return 'apply';
  }

  public get isApplyingPromoCode(): boolean {
    return this.paymentStore.applyPromoCodeState === ApplyPromoCodeProcess.SEND;
  }

  public switchShowingPromoCodes(): void {
    this.isShowPromoCodeField = !this.isShowPromoCodeField;
  }

  public sendPromoCode(promo: string, isRemove: boolean = false): void {
    if (isRemove) {
      this.promoCode = null;
      this.discountService.removeDiscountFromStorage();
      this.cartStore.discounts = [];
      this.paymentStore.applyPromoCodeState = ApplyPromoCodeProcess.INIT;
      this.cartStore.setCoupons([]);
      this.orderApiService.calculateOrders(true);
      return;
    }
    this.paymentStore.applyPromoCodeState = ApplyPromoCodeProcess.SEND;
    this.showWrongPromoCodeError = false;
    this.orderApiService.getDiscountByPromoCode(this.restaurant.locationId, promo.replace(/\s+/g, '')).subscribe(
      (discount: Coupon) => {
        if (discount == null) {
          this.showWrongPromoCodeError = true;
          this.paymentStore.applyPromoCodeState = ApplyPromoCodeProcess.FAILED;
          this.discountService.removeDiscountFromStorage();
          return;
        }
        discount.locationId = this.restaurant.locationId;
        if (this.cartStore.discounts == null) {
          this.cartStore.discounts = [discount];
        }
        if (this.cartStore.discounts.find((disc) => disc.id === discount.id)) {
          this.orderApiService.calculateOrders();
        } else {
          this.cartStore.discounts = [...this.cartStore.discounts, discount];
          this.orderApiService.calculateOrders();
        }
        this.paymentStore.applyPromoCodeState = ApplyPromoCodeProcess.SUCCESS;
      },
      () => {
        this.showWrongPromoCodeError = true;
        this.paymentStore.applyPromoCodeState = ApplyPromoCodeProcess.FAILED;
        this.discountService.removeDiscountFromStorage();
      }
    );
  }

  private getPromoCodeData(): void {
    if (this.restaurant?.enablePromoCodes && this.restaurantStore.discountPromo) {
      this.promoCode = this.restaurantStore.discountPromo;
      this.isShowPromoCodeField = true;
      this.sendPromoCode(this.restaurantStore.discountPromo);
      return;
    }
    if (this.cartStore.discounts && this.cartStore.discounts.length) {
      this.promoCode = this.cartStore.discounts[0].code;
      this.switchShowingPromoCodes();
    }
  }

  public selectSubscriptionPhase(phase: SubscriptionPhase): void {
    if (phase.selected) {
      return;
    }
    if (this.isCadenceEqualsValue('daily')) {
      this.deselectDaysToSubscribe();
    }
    this.cartStore.subscriptionsData.forEach((subscriptionPhase) => {
      subscriptionPhase.uid === phase.uid ? (subscriptionPhase.selected = true) : (subscriptionPhase.selected = false);
    });
    if (this.isCadenceEqualsValue('daily')) {
      this.selectAllDaysToSubscribe();
    }
  }

  public selectSubscriptionPeriod(phase: SubscriptionPhase, selectedPeriod: SelectDataState): void {
    if (!phase.selected) {
      this.selectSubscriptionPhase(phase);
      if (selectedPeriod.selected) {
        return;
      }
    }
    selectedPeriod.selected = !selectedPeriod.selected;
  }

  public isCadenceEqualsValue(value: string): boolean {
    return this.selectedSubscriptionPhase?.cadence.toLowerCase() === value;
  }

  public selectAllDaysToSubscribe(): void {
    this.daysToSelect.forEach((day) => (day.selected = true));
  }

  public deselectDaysToSubscribe(): void {
    this.daysToSelect.forEach((day) => (day.selected = false));
  }

  private findFirstInvalidField(): ElementRef {
    if ((this.schedulePickupInvalid || this.pickupTimeInvalid) && !this.isTableSideSelected && !this.isDeliverySelected) {
      return this.scheduledPickupField;
    } else if (this.tableNumberFieldInvalid && this.isTableSideSelected) {
      return this.tableNumberField;
    } else if (!this.tabOptionSelected && this.isTableSideSelected && this.restaurant && this.restaurant.isTabsEnabled) {
      return this.enableTabField;
    } else if (this.phoneInvalid) {
      return this.phoneFieldComponent;
    } else if (this.deliveryAddressInvalid || this.deliveryEstimateInvalid) {
      return this.deliveryAddressForm;
    } else if (this.deliveryTimeInvalid) {
      return this.deliveryTimepicker;
    } else if (this.nameFieldsInvalid || this.billingAddressInvalid || this.emailAddressInvalid) {
      return this.paymentField;
    } else if (this.tippingInvalid) {
      return this.tipAmountFieldComponent;
    } else if (!this.isSelectedSubscriptionDay) {
      return this.subscriptionDaysSelect;
    } else if (!this.isSelectedSubscriptionPeriod) {
      return this.subscriptionPeriodSelect;
    }
  }

  public itemLeadTimeValid(item: CartItem): boolean {
    return this.itemValidate(item, this.validateItemLeadTime(item));
  }

  public itemAvailableDaysValid(item: CartItem): boolean {
    return this.itemValidate(item, this.validateItemAvailableDays(item));
  }

  public itemAvailableFulfillmentValid(item: CartItem): boolean {
    return this.itemValidate(item, this.validateItemAvailableFulfillments(item));
  }

  public itemAvailableDatetimeRange(item: CartItem): boolean {
    return this.itemValidate(item, this.validateItemDatetimeRange(item));
  }

  public itemRestaurantAvailableFulfillment(item: CartItem): boolean {
    return this.itemValidate(item, this.validateItemRestaurantFulfillment(item));
  }

  public itemRestaurantAvailableTime(item: CartItem): boolean {
    return this.itemValidate(item, this.validateItemRestaurantTime(item));
  }

  public itemValidate(item: CartItem, valid: boolean): boolean {
    let itemValid = true;
    this.menuItemsValidations.forEach((menuItem) => {
      if (menuItem.item === item) {
        menuItem.isValid = valid;
        itemValid = menuItem.isValid;
      }
    });
    return itemValid;
  }

  private validateItem(item: CartItem): boolean {
    const isValidLeadTime = this.validateItemLeadTime(item);
    const isValidWeekDay = this.validateItemAvailableDays(item);
    const isValidFulfillment = this.validateItemAvailableFulfillments(item);
    const isValidDatetimeRange = this.validateItemDatetimeRange(item);
    const isValidRestaurantFulfillment = this.isGroup ? this.validateItemRestaurantFulfillment(item) : true;
    const isValidRestaurantTime = this.isGroup ? this.validateItemRestaurantTime(item) : true;

    return isValidLeadTime && isValidWeekDay && isValidFulfillment && isValidDatetimeRange && isValidRestaurantFulfillment && isValidRestaurantTime;
  }

  private validateItemLeadTime(item: CartItem): boolean {
    if (item == null || item.variation == null) {
      return;
    }
    if (item.variation.isLeadTimesEnabled) {
      if (this.isGroup) {
        return this.itemValidateService.validLeadTime(
          item.variation,
          this.restaurantStore.findLocationById(this.groupRestaurants, item.locationId)?.hoursOfOperation
        );
      }
      return this.itemValidateService.validLeadTime(item.variation, this.restaurant?.hoursOfOperation);
    } else {
      return true;
    }
  }

  private validateItemAvailableDays(item: CartItem): boolean {
    if (item.variation.isDailyRestrictionEnabled) {
      return this.itemValidateService.validDayRestriction(item.variation);
    } else {
      return true;
    }
  }

  private validateItemAvailableFulfillments(item: CartItem): boolean {
    if (item == null || item.variation == null) {
      return false;
    }
    if (item.variation.isFulfillmentRestrictionEnabled) {
      return this.itemValidateService.validFulfillmentRestriction(item.variation, this._selectedFulfillmentTypeItem, this.isTab);
    } else {
      return true;
    }
  }

  private validateItemDatetimeRange(item: CartItem): boolean {
    if (item.variation.isStartEndDatesEnabled) {
      return this.itemValidateService.validItemDatetimeRange(item.variation);
    } else {
      return true;
    }
  }

  private validateItemRestaurantFulfillment(item: CartItem): boolean {
    if (!this.groupRestaurants || this.selectedFulfillmentTypeItem == null) return true;
    const location = this.findLocationById(item.locationId);
    const locationIndex = this.groupRestaurants.indexOf(location);
    const restaurantFulfillment = this.groupRestaurantsFulfillment[locationIndex].find(
      (fulfillment) => fulfillment.type === this.selectedFulfillmentTypeItem.type
    );
    return !!restaurantFulfillment;
  }

  private validateItemRestaurantTime(item: CartItem): boolean {
    if (!this.groupRestaurants) return true;
    const location = this.findLocationById(item.locationId);
    return this.itemValidateService.validItemRestaurantWorkHours(this.restaurantsWorkHoursDaysInAdvance[this.groupRestaurants.indexOf(location)]);
  }

  public filterLoyaltyRewards(loyaltyRewards: LoyaltyRewardTier[]): LoyaltyRewardTier[] {
    if (!loyaltyRewards || loyaltyRewards.length === 0) {
      return [];
    }
    const filteredLoyaltyRewards = [];
    for (const reward of loyaltyRewards) {
      const { scope, catalog_object_ids } = reward.definition;
      if (scope === LoyaltyRewardScope.CATEGORY) {
        if (this.isCartItemsInCategoryReward(catalog_object_ids, reward.id)) {
          if (!reward.isNamesUpdated) {
            this.modifyCategoryReward(reward, catalog_object_ids);
            reward.isNamesUpdated = true;
          }
          filteredLoyaltyRewards.push(reward);
        }
      } else if (scope === LoyaltyRewardScope.ITEM_VARIATION) {
        if (this.isCartItemInItemReward(catalog_object_ids)) {
          if (!reward.isNamesUpdated) {
            this.modifyItemReward(reward, catalog_object_ids);
            reward.isNamesUpdated = true;
          }
          filteredLoyaltyRewards.push(reward);
        }
      } else if (scope === LoyaltyRewardScope.ORDER) {
        if (!reward.isNamesUpdated) {
          reward.name += ` (${reward.points} ${reward.points === 1 ? this.pointsName.one : this.pointsName.other} used)`;
          reward.isNamesUpdated = true;
        }
        filteredLoyaltyRewards.push(reward);
      } else {
        if (!reward.isNamesUpdated) {
          reward.name += ` (${reward.points} ${reward.points === 1 ? this.pointsName.one : this.pointsName.other} used)`;
          reward.isNamesUpdated = true;
        }
        filteredLoyaltyRewards.push(reward);
      }
    }
    return filteredLoyaltyRewards;
  }

  private sortLoyaltyRewardsByPercent(loyaltyRewards: LoyaltyRewardTier[]): void {
    if (loyaltyRewards && loyaltyRewards.length > 1) {
      loyaltyRewards.sort((a, b) => {
        const discountA = Number(a.definition.percentage_discount);
        const discountB = Number(b.definition.percentage_discount);
        if (discountA > discountB) {
          return 1;
        }
        if (discountA < discountB) {
          return -1;
        }
        return 0;
      });
    }
  }

  private isCartItemsInCategoryReward(categoryCatalog: string[], rewardId: string): boolean {
    for (const categoryId of categoryCatalog) {
      if (this.menuItemsInCart.find((item) => item.categoryId === categoryId)) {
        return true;
      }
      if(this.hasRewardItem(rewardId)){
        return true;
      }
    }
    return false;
  }

  private hasRewardItem(rewardId) {
    const cartVariationIds = this.menuItemsInCart.map((item)=>item.variation.id);
    const rewardProduct = this.restaurantStore.rewardProducts.find((r)=>r.id == rewardId);
    if (!rewardProduct) {
      return false;
    }
    return rewardProduct.items.items.some((item) =>
      item.match_variation_ids.some((variationId) => cartVariationIds.includes(variationId))
    );

  }

  private modifyCategoryReward(loyaltyReward: LoyaltyRewardTier, categoryCatalog: string[]): void {
    if (loyaltyReward && loyaltyReward?.name) {
      loyaltyReward.name += ` (${loyaltyReward.points} ${loyaltyReward.points === 1 ? this.pointsName.one : this.pointsName.other} used) -`;
      loyaltyReward.name = loyaltyReward.name.slice(0, -2);
    }
  }

  private isCartItemInItemReward(itemCatalog: string[]): boolean {
    for (const itemId of itemCatalog) {
      if (this.menuItemsInCart.find((item) => item.variation.id === itemId)) {
        return true;
      }
    }
    return false;
  }

  private modifyItemReward(loyaltyReward: LoyaltyRewardTier, itemCatalog: string[]): void {
    loyaltyReward.name += ` (${loyaltyReward.points} ${loyaltyReward.points === 1 ? this.pointsName.one : this.pointsName.other} used) -`;
    loyaltyReward.name = loyaltyReward.name.slice(0, -2);
  }

  private isRestaurantItemInCart(locationId: string): boolean {
    return !!this.menuItemsInCart.find((item) => item.locationId === locationId);
  }

  private saveCustomerToStorage(): void {
    if (this.paymentStore.customer && this.paymentStore.verificationCustomer && this.token) {
      this.storageService.set(STORAGE_CUSTOMER_DATA, {
        token: this.token,
        phone: this.paymentStore.customer.phone,
        orderBotUserId: this.paymentStore.customer.orderBotUserId,
      });
    }
  }

  private saveTabToStorage(): void {
    if (this.cartStore.tab) {
      this.storageService.set(STORAGE_TAB_DATA, new TabInStorage(this.cartStore.tab.tab_id, this.cartStore.tab.location_id, false));
    } else if (this.cartStore.groupTab) {
      this.storageService.set(STORAGE_TAB_DATA, new TabInStorage(this.cartStore.groupTab.group_order_id, null, true));
    }
  }

  private waitUntilDataLoad(): void {
    this.isLoading = true;
    this.paymentStore.isWaitingUpdate = true;
  }

  private stopWaitingDataLoad(): void {
    this.isLoading = false;
    this.paymentStore.isWaitingUpdate = false;
  }

  public isActiveLoyaltyReward(loyaltyReward: LoyaltyRewardTier): boolean {
    return this.paymentStore.selectedLoyaltyReward && this.paymentStore.selectedLoyaltyReward.id === loyaltyReward.id;
  }

  private setCustomerLoyaltyRewards(customer: Customer): void {
    if (this.isLoyaltyEnabled) {
      if (this.routeService.getMerchantId() === STONE_CREEK_MERCHANT_ID) {
        this.filteredLoyaltyRewards = this.filterLoyaltyRewards(customer.loyaltyRewardsTier).sort((prev, next) => next.points - prev.points);
      } else {
        this.filteredLoyaltyRewards = this.filterLoyaltyRewards(customer.loyaltyRewardsTier);
        this.sortLoyaltyRewardsByPercent(this.filteredLoyaltyRewards);
      }
    }
  }

  private findLocationById(locationId: string): Restaurant {
    return this.groupRestaurants.find((restaurant) => restaurant.locationId === locationId);
  }

  private findCategoryById(categoryId: string): RestaurantCategory {
    return this.restaurantStore.curCategories.find((category) => category.id === categoryId);
  }

  private createMerchantUrl(locationId: string): string {
    return `merchants/${this.restaurantStore.findLocationById(this.groupRestaurants, locationId).merchantId}`;
  }

  private checkIfNeedEstimate(): void {
    if (this.paymentStore.fulfilmentType === FulfillmentType.DELIVERY && this.paymentStore.deliveryAddress && this.cartStore.deliveryDurationData) {
      this.estimateDelivery();
    }
  }

  private initListeners(): void {
    this.applyPromoCodeState();

    this.paymentStore.verifyCustomerState$.subscribe((state: VerifyProcess) => {
      if (state === VerifyProcess.INIT) {
        this.isLoading = false;
        this.paymentStore.isWaitingUpdate = false;
      }

      if (state === VerifyProcess.VERIFYING) {
        this.paymentStore.isWaitingUpdate = true;
      }

      if (state === VerifyProcess.SUCCESS) {
        this.isLoading = false;
        this.paymentStore.isWaitingUpdate = false;
      }
    });
    this.paymentStatusSubscribe();
    this.restaurantStore.pickupLocationChanged.subscribe((locationId) => {
      if (locationId && this.locationId !== locationId) this.locationId = locationId;
      this.getRestaurant();
    });

    this.restaurantStore.taxes$.subscribe((taxes) => {
      if (taxes) {
        this.taxes = taxes;
      }
    });
  }

  private applyPromoCodeState(): void {
    this.paymentStore.applyPromoCodeState$.subscribe((state: ApplyPromoCodeProcess) => {
      switch (state) {
        case ApplyPromoCodeProcess.INIT: this.paymentStore.isWaitingUpdate = false;
          break;
        case ApplyPromoCodeProcess.FAILED: this.paymentStore.isWaitingUpdate = false;
          break;
        case ApplyPromoCodeProcess.SUCCESS: break;
        case ApplyPromoCodeProcess.SEND: this.paymentStore.isWaitingUpdate = true;
          break;
      }
    });
  }

  private paymentStatusSubscribe(): void {
    this.paymentStore.statePayment$.pipe(takeUntil(this.destroyed$)).subscribe((state: StatePayment) => {
      switch (state) {
        case StatePayment.INIT: this.isLoading = false;
          break;
        case StatePayment.SEND: this.isShowTimeOverErrorMessage = false;
          this.isLoading = true;
          break;
        case StatePayment.WALLET_PROCESS: this.isShowTimeOverErrorMessage = false;
          this.isLoading = true;
          break;
        case StatePayment.SUCCESS: this.successPayment();
          break;
        case StatePayment.SUBSCRIBED: this.subscribePayment();
          break;
        case StatePayment.FAILED: this.isLoading = false;
          this.paymentStore.isWalletPayment = false;
          break;
        case StatePayment.TIMEOVER: this.isShowTimeOverErrorMessage = true;
          this.isLoading = false;
          break;
      }
    });
  }

  private successPayment(): void {
    let baseUrl = this.isGroup ? this.routeService.getGroupUrl() : this.routeService.getLocationUrl();
    if (this.cartStore.groupTab) {
      baseUrl = this.routeService.createGroupUrl(this.cartStore.groupTab.group_id);
    }
    const destination: string = this.isNavigateToCloseTab ? 'close-tab' : 'order-complete';
    if (!this.sharedOrderId) {
      this.isNavigateToCloseTab = false;
      this.paymentStore.selectedLoyaltyReward = null;
      this.resetDeliveryEstimate();
      this.saveCustomerAddress();
      this.saveTabToStorage();
      this.isLoading = false;
      this.cartStore.discounts = [];
      this.restaurantStore.discountPromo = null;
      this.cartStore.setCoupons([]);
      this.paymentStore.applyPromoCodeState = ApplyPromoCodeProcess.INIT;
      this.updateCustomer(this.paymentStore.givenName, this.paymentStore.familyName, this.paymentStore.email, this.paymentStore.billingAddress);
    }
    this.paymentStore.setStatePayment(StatePayment.INIT);
    if (this.isStoneCreek) {
      this.router.navigate([baseUrl, destination, 'order-confirmation']);
    } else {
      const sharedOrder = sessionStorage.getItem(UrlParam.sharedOwnerId);
      if (sharedOrder) {
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.delete(sharedOrder);
        sessionStorage.removeItem(UrlParam.sharedOwnerId);
        sessionStorage.removeItem(UrlParam.cartItems);
        sessionStorage.removeItem(UrlParam.sharedOrderIds);
        const newUrl = `${baseUrl}/${destination}?${queryParams.toString()}`;
        this.router.navigateByUrl(newUrl);
      }
      this.router.navigate([baseUrl, destination]);
    }
  }

  private subscribePayment(): void {
    this.resetDeliveryEstimate();
    this.saveCustomerAddress();
    this.paymentStore.selectedLoyaltyReward = null;
    this.updateCustomer(this.paymentStore.givenName, this.paymentStore.familyName, this.paymentStore.email, this.paymentStore.billingAddress);
    if (!this.restaurantStore.updateSubscriptionHistory) {
      this.restaurantStore.updateSubscriptionHistory = true;
    }
    sessionStorage.setItem('customerId', this.paymentStore.customer.squareCustomerId);
    this.router.navigate([this.routeService.getLocationUrl(), 'my-subscriptions']).catch((error) => console.error(error));
  }

  public async navigateBack(): Promise<any> {
    const locationId = await this.storageService.get('currentRestaurantId');
    this.clearData();
    if (this.restaurantStore.isGroup) {
      const groupUrl = this.routeService.getGroupUrl();
      this.router.navigate([groupUrl]);
    } else {
      const baseUrl = this.routeService.getBaseUrl();
      this.router.navigate([baseUrl, 'locations', locationId]);
    }
  }

  private clearData(): void {
    this.cartStore.deliveryResponseData = null;
    this.cartStore.deliveryAt = null;
    this.cartStore.pickupAt = null;
    this.cartStore.isAsap = true;
  }

  private async savePaymentDetailsAlert(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      const alert = await this.alertController.create({
        cssClass: 'verify-phone-alert',
        header: 'Save payment details?',
        message: 'Verify phone to collect rewards and save payment information.',
        buttons: [
          {
            text: 'Verify Phone',
            cssClass: 'verify-phone-btn',
            handler: () => {
              this.content.scrollToPoint(0, this.phoneFieldComponent.nativeElement.offsetTop, 300);
              this.children.allowResendCode();
              resolve(false);
            },
          },
          {
            text: 'or place order without saving',
            cssClass: 'place-order-btn',
            handler: () => {
              resolve(true);
            },
          },
        ],
      });
      await alert.present();
    });
  }

  private calculateGiftCardBalance(): void {
    if (this.subTotal <= (this.flexibleGiftCardBalance || this.giftCard.balance)) {
      this.flexibleGiftCardBalance = this.subTotal;
      return;
    } else if (this.subTotal <= this.giftCard.balance) {
      this.flexibleGiftCardBalance = this.subTotal;
      return;
    }
    this.flexibleGiftCardBalance = this.giftCard.balance;
  }

  private getSharedOrders(): void {
    if (this.sharedOrderService.sharedOwnerId$) {
      this.sharedOrderService.getAllSharedOrders(this.locationId);
    }
  }

  public isDisplayKyooFee():boolean {
    return this.restaurant && this.restaurant.displayKyooFeeOnMenu;
  }

  private async getMerchant(): Promise<void> {
    this.merchantStore.merchantData$.pipe(takeUntil(this.destroyed$)).subscribe(merchant => {
      this.merchant = merchant;
      if(merchant && merchant.useFlavorShiftsTime){
        this.restaurantStore.getRestaurants().subscribe(restaurants =>{
          if(restaurants.length) {
            this.orderWithFlavorStore.restaurants$.pipe(takeUntil(this.destroyed$)).subscribe((r)=>{
              if(r.length){
                this.getFlavorRestaurant()
              }
            })
            this.orderWithFlavorStore.flavorShifts$.pipe(takeUntil(this.destroyed$)).subscribe((s)=>{
              if(s.length){
                if(this.orderWithFlavorStore.shift){
                  this.shifts = [this.orderWithFlavorStore.shift]
                } else {
                  this.shifts = s.filter((s)=>s.kyoo_location_id == this.locationId)
                }
                const uniqueDeliveryLocations = [
                  ...new Set(
                      this.shifts.flatMap(s =>
                          s.location_id.delivery_locations.map(loc => loc.name)
                      )
                  )
              ];
              for(const shift of this.shifts) {
                if(shift.location_id.delivery_enabled){
                  this.isCfDeliveryEnabled = true;
                  break;
                }
              }
              this.cfDeliveryLocations = Array.from(uniqueDeliveryLocations);
              }
            })
          }
        })
      }
    })
  }

  private async getFlavorRestaurant(): Promise<void> {
    let address = await this.storageService.get("address")
    this.orderWithFlavorStore.getRestaurantById(this.locationId, address)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(restaurant => {
        if(restaurant){
          this.restaurant.address = restaurant.address
        }
      }
      );
  }
}
